var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _line61, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _line62, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _line63, _polyline, _line64, _line65, _line66, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _line67, _line68, _line69, _line70, _line71, _path139, _line72, _path140, _path141, _polygon11, _polyline2, _line73, _path142, _path143, _path144, _path145, _line74, _path146, _path147, _line75, _path148, _path149, _polyline3, _path150, _polyline4, _line76, _path151, _path152, _path153, _line77, _line78, _path154, _line79, _path155, _path156, _polyline5, _line80, _line81, _path157, _polyline6, _polyline7, _path158, _line82, _polyline8, _line83, _line84, _line85, _path159, _path160, _path161, _path162, _line86, _line87, _line88, _path163, _path164, _line89, _polyline9, _path165, _line90, _line91, _line92, _line93, _line94, _path166, _polyline10, _line95, _line96, _line97, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _line98, _line99, _line100, _path174, _line101, _polyline11, _polyline12, _path175, _line102, _line103, _polyline13, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _path176, _polyline14, _line115, _line116, _line117, _line118, _line119, _path177;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 762.81 233.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#fff;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#231f20;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;}.cls-1{stroke-width:0.38px;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{fill-rule:evenodd;}.cls-2{fill:#8e9091;}.cls-10,.cls-11,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-width:0.06px;}.cls-3,.cls-9{fill:#dbdbdb;}.cls-4{fill:#e8f2f1;}.cls-5{fill:#4b5353;}.cls-6{fill:#231f20;}.cls-10,.cls-7,.cls-8{fill:none;}.cls-7,.cls-8{stroke-linejoin:round;stroke-width:0.09px;}.cls-11{fill:#ed2129;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "saloon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.74,231.18l-2-7.65L879.64,207l1-.16a.62.62,0,0,0,.41-.08.58.58,0,0,0,.24-.49l-.16-3.17c0-.4-.08-.73-.81-1.46a31.36,31.36,0,0,0-3-2.68,6.25,6.25,0,0,0-1.86-1.31,8.32,8.32,0,0,0-2-.31l-4.31-.5-1.13-.64c1.29-4,2.51-8,3.33-10.49a19.82,19.82,0,0,0,1.05-4.63,21.79,21.79,0,0,0-.32-4c-.32-2.12-.65-5.53-1-8.94L866.71,151c-.73-2-1.54-4.06-2.35-5.93s-1.7-3.58-2.28-5.13-.81-2.76-1.46-3.24-1.47-.25-2.28-.08a11.11,11.11,0,0,1-4.06-.09c-2.36-.33-6.33-.89-11.79-1.7s-12.27-1.71-18.36-2.6S812.83,130.72,809,130s-6.34-1.54-8-2a4.72,4.72,0,0,0-3.09.08l-18.69,4.39c-3.9-1.3-7.73-2.69-16.18-6.18s-21.37-9-33.89-14-24.62-9.5-34.21-12.92-16.83-5.77-24.06-8l-1.06-.4L681,85.21c-1.47-.48-2.93-.9-6.1-1.79s-8.29-2.2-12.6-3.17-8-1.79-11.62-2.44l.17-4.87a1.67,1.67,0,0,0-.25-1c-.16-.32-.33-.57-.65-.65a.84.84,0,0,0-.89,0,2.52,2.52,0,0,0-1.06.49l-5.69,4.55A325,325,0,0,0,607,72c-14.3-1.13-32.58-1.94-51.84-2.19s-39.42.32-56.81,1.21-31.86,2.36-43.49,4.32a220.75,220.75,0,0,0-24.79,5.92c-4.47,1.39-4.79,1.47-4.95,1.71L436,87.57a.74.74,0,0,1,.08,1c-.17.33-.73.49-1.22.65s-1.13.49-6.91,2.93-16.82,6.91-28.69,13-24.79,13.65-34.05,19.1-15,8.78-20.73,12.11a30.63,30.63,0,0,1-7.15,3.57,48.66,48.66,0,0,1-9.18,1.79l-15.36.33c-3.58-.08-7.16-.25-9.67-.57a51.61,51.61,0,0,0-5.86-.65c-1.71,0-3.41.41-11.46,1.55s-22.5,2.92-39.66,5.61-36.82,5.92-52.58,9.83-27.55,8-36.9,12.59a85.78,85.78,0,0,0-22.67,15l-4.88,3.25a3.94,3.94,0,0,0-.73.81,25.6,25.6,0,0,0-1.79,3,54.7,54.7,0,0,0-2.36,5.61,41.3,41.3,0,0,0-1.38,5.69,16.48,16.48,0,0,0-.24,3.81,1,1,0,0,0-.17.58,3.3,3.3,0,0,0,.09,1c.08.25.16.25.32.25l.25.07c-.08.16-.08.25,0,.33s.24.25.4.25l4.15,1a.3.3,0,0,0-.08.24c.08.08.08.08.16.08l.49.08-3.1,1.06c-.4.33-.81.58-1.45,1.14a26.38,26.38,0,0,0-2.12,2.2,6.61,6.61,0,0,0-1.22,2h1.14c-.08,1.06-.17,2.12-.17,3.91s-.15,4.3-.23,6.33.08,3.5.16,4.47a3.83,3.83,0,0,0,.48,1.63l3.33.9V241l-.81.16-2.19.49a.29.29,0,0,1-.24.08V242l.16.09-.33.08a.67.67,0,0,0-.33.16.81.81,0,0,0-.07.4.38.38,0,0,0,.07.41c.09.09.17.09.33.17s.25.07.33.07l.08,1.06-.74.81a1,1,0,0,0-.32.41.51.51,0,0,0-.08.33l.08.32c-.08.16-.08.25-.16.41a2.08,2.08,0,0,0,.08.65,1.38,1.38,0,0,0,.17.57,1.51,1.51,0,0,0,.32.4c.08.17.08.33.16.49a.42.42,0,0,0,.33.16l2.76.89.25.5-1.22.4v.41l-2.37.73a.51.51,0,0,0-.32.08l-.24.25c-.08.08-.17.16-.17.24a.29.29,0,0,0-.08.24V253c.08.08.25.24.33.24l1.38.09v.15c0,.08.08.08.24.17s.58.24,1,.41H125l.25,5-1.46.25-1,.41a.17.17,0,0,0-.16.15c-.08,0,0,.08,0,.25H121.6c-.24.08-.48.16-.56.41s.16.4.32.73.49.65.65.89a1,1,0,0,0,.65.25c-.08.08-.16.15-.08.32a1.47,1.47,0,0,0,.49.57,5.8,5.8,0,0,0,1.38.4,24.23,24.23,0,0,0,2.76.09,28.14,28.14,0,0,1,4.47.49,43.74,43.74,0,0,1,5,1.37c3.09,1,6.18,2,8.61,2.85s4.23,1.54,6.34,2.12a29,29,0,0,0,7.15,1.21h36.5a3.88,3.88,0,0,0,1.71-.24c.4-.24,1-.74,1-1.3l.17-3.25-.33-8.05v-4.47a92.27,92.27,0,0,1,.4-9.75A82.15,82.15,0,0,1,200.77,229a60.86,60.86,0,0,1,7.88-17.07,55.22,55.22,0,0,1,30.72-22.75,68.38,68.38,0,0,1,19.75-2.93,65.73,65.73,0,0,1,19,2.93,63.41,63.41,0,0,1,17.8,8.69,58.56,58.56,0,0,1,21.38,30.88A100.72,100.72,0,0,1,321,251.17l.4,5.36.41,11.47v1.29a2,2,0,0,0,.24,1.14c.24.25.74.16,1.3.16l316.07-4.15c1,0,2,.17,2.6-.23s.66-1.31.74-2.28V249.46l.57-5.52c.73-3.42,1.62-6.84,3-11.55s3.41-10.73,6.65-16.17a50.2,50.2,0,0,1,13.34-14.14,60.28,60.28,0,0,1,18-8.94,72.24,72.24,0,0,1,20.88-3.09,68.92,68.92,0,0,1,20.49,3.17,54.63,54.63,0,0,1,30.56,22.43,65.71,65.71,0,0,1,9.83,26l.48,4.55c.25,2.11.41,4.23.66,7.07s.48,6.51.73,10.08c-.08.4.16.81,1.22,1s3.08,0,11.46-.66,23.16-2,37-3.33,26.9-2.6,34.13-3.41,8.78-1,10.08-1.47a12,12,0,0,0,3.42-2.1c.89-.9,1.62-1.72,2.51-2.61s2-1.95,2.93-3.08,1.87-2.45,2.52-3.34a5.16,5.16,0,0,1,1.79-1.63,5,5,0,0,1,1.78-.24c.41,0,.65,0,.9-.24a3.71,3.71,0,0,0,.81-1.06l1.87-4.15.24-.64-.49-.9a1.2,1.2,0,0,0,.49-.65,2.2,2.2,0,0,0,.25-.81,4,4,0,0,0,.08-1,.9.9,0,0,0-.16-.66.75.75,0,0,0-.49-.24c-.41,0-.73.08-1-.08s-.4-.57-.57-.89Z",
    transform: "translate(-118.64 -69.63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125,235.08V241l-.81.16-2.19.49a.29.29,0,0,1-.24.08V242l.16.09-.33.08a.67.67,0,0,0-.33.16.81.81,0,0,0-.07.4.38.38,0,0,0,.07.41c.09.09.17.09.33.17s.25.07.33.07l.08,1.06-.74.81a1,1,0,0,0-.32.41.51.51,0,0,0-.08.33l.08.32c-.08.16-.08.25-.16.41a2.08,2.08,0,0,0,.08.65,1.38,1.38,0,0,0,.17.57,1.51,1.51,0,0,0,.32.4c.08.17.08.33.16.49a.42.42,0,0,0,.33.16l2.76.89.25.5-1.22.4v.41l55-2.52a5.15,5.15,0,0,0,1.14-.08c.32-.17.56-.33.81-.49-2.2-3.74-4.55-7.48-6.18-9.84a19,19,0,0,0-3.66-4.38,9.19,9.19,0,0,0-3.9-2,20.79,20.79,0,0,0-5.69-.49l-39.5,2.76Z",
    transform: "translate(-118.64 -69.63)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M766.58,246.21l83.55-4.55,1.14.81a1.53,1.53,0,0,0,.57.33,2.74,2.74,0,0,0,.81,0l21.79-1.22c.24-.08.57-.08.73-.16a2.55,2.55,0,0,0,.65-.66l1.7-2.92v-.32a.62.62,0,0,0-.08-.33l2.93-.17.24-.64-.49-.9-114,6.18Z",
    transform: "translate(-118.64 -69.63)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.12,238.33c-.41,0-.82.08-1.22.08h-.73c-.17,0-.25,0-.33-.08v-.25l.16-19-.16-.08c-.08,0-.08-.08-.17-.16a.82.82,0,0,1,.25-.65.92.92,0,0,1,.41-.25,3.66,3.66,0,0,1,1-.08h1.14c-.08,1.06-.17,2.12-.17,3.91s-.15,4.3-.23,6.33.08,3.5.16,4.47a3.83,3.83,0,0,0,.48,1.63l-.41,3.9a.27.27,0,0,1-.07.16s0,.09-.08.09Z",
    transform: "translate(-118.64 -69.63)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M866.71,151a19.94,19.94,0,0,1,2.28,3.49,23.64,23.64,0,0,1,1.55,4.15,24.66,24.66,0,0,1,.73,4.39,26.47,26.47,0,0,1-.25,5Z",
    transform: "translate(-118.64 -69.63)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.38,257.18a5.58,5.58,0,0,1-1.38-.9,7.75,7.75,0,0,1-1.71-1,25.71,25.71,0,0,1-2.11-2l-3,.09v.15c0,.08.08.08.24.17s.58.24,1,.41H125l.25,5-1.46.25-1,.41a.17.17,0,0,0-.16.15c-.08,0,0,.08,0,.25H121.6c-.24.08-.48.16-.56.41s.16.4.32.73.49.65.65.89a1,1,0,0,0,.65.25l11.3-.58-.81-1.29a.7.7,0,0,1,0-.58c.07-.15.4-.23.65-.32l41.53-2.11a15.12,15.12,0,0,0,3.08-.73,18.73,18.73,0,0,0,3-1.71l-49.33,2.27A5.47,5.47,0,0,1,130.38,257.18Z",
    transform: "translate(-118.64 -69.63)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.84,259.05v-4.47l-16.42.57a18.73,18.73,0,0,1-3,1.71,15.12,15.12,0,0,1-3.08.73L133.8,259.7c-.25.09-.58.17-.65.32a.7.7,0,0,0,0,.58l.81,1.29Z",
    transform: "translate(-118.64 -69.63)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M779.27,132.51c-3.9-1.3-7.73-2.69-16.18-6.18s-21.37-9-33.89-14-24.62-9.5-34.21-12.92-16.83-5.77-24.06-8l10.64-5.77c6,1.72,12.12,3.59,21.7,6.75s22.92,7.64,39.34,13.74,35.92,13.89,55.35,21.94Z",
    transform: "translate(-118.64 -69.63)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M669.87,91.06,681,85.21a1.1,1.1,0,0,0,.32.24,2.72,2.72,0,0,0,.24.24l-10.64,5.77Z",
    transform: "translate(-118.64 -69.63)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.84,259.05v-4.47a92.27,92.27,0,0,1,.4-9.75A82.15,82.15,0,0,1,200.77,229a60.86,60.86,0,0,1,7.88-17.07,55.22,55.22,0,0,1,30.72-22.75,68.38,68.38,0,0,1,19.75-2.93,65.73,65.73,0,0,1,19,2.93,63.41,63.41,0,0,1,17.8,8.69,58.56,58.56,0,0,1,21.38,30.88A100.72,100.72,0,0,1,321,251.17l.4,5.36.41,11.47H310.07a63.85,63.85,0,0,0,3.66-19,51,51,0,0,0-2.44-17.06,56.29,56.29,0,0,0-7.79-15.28,55.39,55.39,0,0,0-12.28-12.36,58.55,58.55,0,0,0-15.28-7.71,55,55,0,0,0-33,0,58.61,58.61,0,0,0-15.29,7.71,53.51,53.51,0,0,0-12.27,12.36,56.33,56.33,0,0,0-7.8,15.28,50.65,50.65,0,0,0-2.44,16.9,58.51,58.51,0,0,0,3.33,18.29H198.17Z",
    transform: "translate(-118.64 -69.63)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.37,256.53c49.17-1.29,98.43-2.6,152-3.74s111.51-2.27,169.38-3.33l.57-5.52c-58.12,1.14-116.14,2.35-169.95,3.57S370.22,250,321,251.17Z",
    transform: "translate(-118.64 -69.63)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.16,82.94,436,87.57a.74.74,0,0,1,.08,1c-.17.33-.73.49-1.22.65s-1.13.49-6.91,2.93-16.82,6.91-28.69,13-24.79,13.65-34.05,19.1-15,8.78-20.73,12.11a30.63,30.63,0,0,1-7.15,3.57,48.66,48.66,0,0,1-9.18,1.79,61.31,61.31,0,0,0,8-2.35,63,63,0,0,0,7.32-3.74c5.6-3.58,11.21-7,20.64-12.35s22.51-12.92,34.87-19.19a323.11,323.11,0,0,1,36-15.76L424.1,83.58c.17-.16.25-.32.41-.41a1.52,1.52,0,0,1,.65-.16Z",
    transform: "translate(-118.64 -69.63)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.76,142l15.36-.33a61.31,61.31,0,0,0,8-2.35,63,63,0,0,0,7.32-3.74c5.6-3.58,11.21-7,20.64-12.35s22.51-12.92,34.87-19.19a323.11,323.11,0,0,1,36-15.76L424.1,83.58c-7.4,2.85-14.71,6-26.33,11.62s-27.63,13.74-42.59,21.86-28.85,16.34-42.42,25Z",
    transform: "translate(-118.64 -69.63)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M642.73,249.46l.57-5.52c.73-3.42,1.62-6.84,3-11.55s3.41-10.73,6.65-16.17a50.2,50.2,0,0,1,13.34-14.14,60.28,60.28,0,0,1,18-8.94,72.24,72.24,0,0,1,20.88-3.09,68.92,68.92,0,0,1,20.49,3.17,54.63,54.63,0,0,1,30.56,22.43,65.71,65.71,0,0,1,9.83,26l.48,4.55c.25,2.11.41,4.23.66,7.07s.48,6.51.73,10.08l-11.05.49a52.79,52.79,0,0,0,2.35-15.61,51.52,51.52,0,0,0-2.6-16.33,55.23,55.23,0,0,0-20-27.64,58.7,58.7,0,0,0-15.28-7.71,55,55,0,0,0-33,0,58.61,58.61,0,0,0-15.29,7.71,56.86,56.86,0,0,0-12.27,12.36,54.5,54.5,0,0,0-10.32,31.77,56.69,56.69,0,0,0,2.76,16.42l-10.56-.89Z",
    transform: "translate(-118.64 -69.63)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.1,188.67a3.79,3.79,0,0,1,1-1.3c.64-.65,1.7-1.63,2.76-2.52l-7.88.57-4.88,3.25a3.94,3.94,0,0,0-.73.81,25.6,25.6,0,0,0-1.79,3,54.7,54.7,0,0,0-2.36,5.61,41.3,41.3,0,0,0-1.38,5.69,23.66,23.66,0,0,0-.32,3.81,2.32,2.32,0,0,0-.09.82,2.26,2.26,0,0,0,.09.81.31.31,0,0,0,.32.17l.25.07c-.08.16-.08.25,0,.33s.24.25.4.25l4.15,1a.3.3,0,0,0-.08.24c.08.08.08.08.16.08l.49.08L145.58,208a56.13,56.13,0,0,1-6.09-6.9,35.12,35.12,0,0,1-3.1-5.13,9.68,9.68,0,0,1-1-2.11,2.06,2.06,0,0,1,.41-1.13c.23-.42.48-.82.89-1.47s1-1.38,1.46-2.19c-.08-.08-.08-.17,0-.41Z",
    transform: "translate(-118.64 -69.63)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.11,205c-5.61,1.06-12.11,2.12-18.53,3a56.13,56.13,0,0,1-6.09-6.9,35.12,35.12,0,0,1-3.1-5.13,9.68,9.68,0,0,1-1-2.11,2.06,2.06,0,0,1,.41-1.13c.23-.42.48-.82.89-1.47s1-1.38,1.46-2.19c8.54-1.63,17-3.09,24.38-4.23s13.74-1.87,20.81-2.6,15-1.22,22.84-1.71c-.17.81-.25,1.62-3,4.15s-8.13,6.74-13.57,11.05a37.37,37.37,0,0,1-10.81,5.93A95.49,95.49,0,0,1,164.11,205Z",
    transform: "translate(-118.64 -69.63)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137,193.79c.25-.33.41-.65.66-1,.48-.74,1-1.55,1.46-2.37,4-.72,7.88-1.45,11.86-2.11s7.88-1.3,11.78-1.86c3.5-.58,6.92-1.06,10.33-1.47s6.9-.81,10.41-1.14c3.24-.32,6.57-.56,9.91-.89s6.58-.4,9.91-.65c-.41.41-.89.81-1.3,1.22s-.81.73-1.21,1.06-.82.73-1.23,1c-.81.74-1.7,1.38-2.51,2.11-2.77,2.28-5.61,4.47-8.46,6.67a40.52,40.52,0,0,1-5,3.33,56.8,56.8,0,0,1-5.44,2.36c-.9.32-1.87.65-2.84.9l-2.85.72c-1.38.33-2.84.65-4.31.9s-2.92.56-4.31.81c-3,.49-5.93,1.06-8.85,1.46s-5.94,1-8.87,1.39c-.73-.73-1.46-1.46-2.1-2.2s-1.39-1.54-2-2.36-1.38-1.78-1.95-2.68a19.57,19.57,0,0,1-1.7-2.84c-.5-.81-.9-1.63-1.39-2.44Z",
    transform: "translate(-118.64 -69.63)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.11,205c-5.61,1.06-12.11,2.12-18.53,3l-17.39,3.41-3.1,1.06c6.92-1.38,13.82-2.68,20.57-3.9s13.33-2.27,18.93-3.33,10.25-2,13.17-2.85a18.9,18.9,0,0,0,5.7-2.43c1.7-1.06,4-2.6,6.09-4.23a37.37,37.37,0,0,1-10.81,5.93A95.49,95.49,0,0,1,164.11,205Z",
    transform: "translate(-118.64 -69.63)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.1,188.67a3.79,3.79,0,0,1,1-1.3c.64-.65,1.7-1.63,2.76-2.52,3.66-.73,7.4-1.38,11.87-2.11s9.91-1.63,14.87-2.28,9.67-1.06,14.79-1.46,10.81-.73,14.14-.81a21.1,21.1,0,0,1,5.44.4,10.29,10.29,0,0,1,2.37.89,1.44,1.44,0,0,1,.81,1.06c-7.89.49-15.77,1.06-22.84,1.71s-13.41,1.46-20.81,2.6-15.84,2.6-24.38,4.23c-.08-.08-.08-.17,0-.41Z",
    transform: "translate(-118.64 -69.63)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.22,204.27a55.39,55.39,0,0,1,12.28,12.36,53.79,53.79,0,0,1,7.71,48.19,53.28,53.28,0,0,1-7.71,15.36,57.2,57.2,0,0,1-12.28,12.28,54,54,0,0,1-15.28,7.71,53.43,53.43,0,0,1-33,0,54.06,54.06,0,0,1-15.29-7.71,55.19,55.19,0,0,1-12.27-12.28,53.3,53.3,0,0,1-7.72-15.36,53.37,53.37,0,0,1,0-32.91,55.23,55.23,0,0,1,20-27.64A58.61,58.61,0,0,1,243,196.56a55,55,0,0,1,33,0A58.55,58.55,0,0,1,291.22,204.27Z",
    transform: "translate(-118.64 -69.63)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736.68,204.27A55.49,55.49,0,0,1,749,216.63a58.43,58.43,0,0,1,7.72,15.28,55,55,0,0,1,0,32.91,53.89,53.89,0,0,1-20.07,27.64,53.7,53.7,0,0,1-48.19,7.71,53.46,53.46,0,0,1-15.37-7.71,58.78,58.78,0,0,1-12.27-12.28,53.3,53.3,0,0,1-7.72-15.36,54.11,54.11,0,0,1,7.72-48.19,56.86,56.86,0,0,1,12.27-12.36,57.87,57.87,0,0,1,15.37-7.71,54.78,54.78,0,0,1,32.91,0,58.7,58.7,0,0,1,15.28,7.71Z",
    transform: "translate(-118.64 -69.63)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.9,218.66a36.57,36.57,0,0,1,13.49,18.61,37.11,37.11,0,0,1,0,22.27,38.37,38.37,0,0,1-5.2,10.32,36.64,36.64,0,0,1-8.29,8.29,36.87,36.87,0,0,1-32.59,5.2,36.17,36.17,0,0,1-10.32-5.2,36.53,36.53,0,0,1-13.49-18.61,36.76,36.76,0,0,1,5.19-32.6,36.64,36.64,0,0,1,8.3-8.28,34.22,34.22,0,0,1,10.32-5.2,35.53,35.53,0,0,1,22.27,0A35.17,35.17,0,0,1,280.9,218.66Z",
    transform: "translate(-118.64 -69.63)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.82,256.53a3,3,0,0,1,.49.57,3.33,3.33,0,0,1,.41.65,3,3,0,0,1,0,1.46,2,2,0,0,1-.41.66,1.56,1.56,0,0,1-.49.56,2.1,2.1,0,0,1-.65.33,2.28,2.28,0,0,1-1.46,0,1.54,1.54,0,0,1-.65-.33,2,2,0,0,1-.57-.56,1.86,1.86,0,0,1-.33-.66,2.28,2.28,0,0,1,0-1.46,2.85,2.85,0,0,1,.33-.65,5.1,5.1,0,0,1,.57-.57,3.94,3.94,0,0,1,.65-.32,2.28,2.28,0,0,1,1.46,0c.25.07.41.24.65.32Z",
    transform: "translate(-118.64 -69.63)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.05,252.23a1.62,1.62,0,0,1-.33.64,1.74,1.74,0,0,1-1.22.9,2.27,2.27,0,0,1-1.46,0,4.43,4.43,0,0,1-.65-.33c-.16-.16-.41-.32-.49-.57a1,1,0,0,1-.32-.64,2.18,2.18,0,0,1,0-1.47,1.65,1.65,0,0,1,.32-.65,3.61,3.61,0,0,1,.49-.57,5.64,5.64,0,0,0,.65-.32,2.15,2.15,0,0,1,1.46,0,3.24,3.24,0,0,1,.74.41c.16.08.32.32.48.48a2.66,2.66,0,0,1,.33.65A2.31,2.31,0,0,1,252.05,252.23Z",
    transform: "translate(-118.64 -69.63)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.51,242.55a2.25,2.25,0,0,1-.73-.08c-.25-.08-.49-.24-.73-.32a3.54,3.54,0,0,1-.49-.57,1.65,1.65,0,0,1-.32-.65,2.21,2.21,0,0,1-.17-.73,2,2,0,0,1,.17-.73,1.63,1.63,0,0,1,.32-.66,1.94,1.94,0,0,1,.57-.57,4.38,4.38,0,0,1,.65-.32,1.83,1.83,0,0,1,.73-.08,2.28,2.28,0,0,1,.73.08,4.93,4.93,0,0,1,.65.32,1.16,1.16,0,0,1,.49.57,1.76,1.76,0,0,1,.41.66c0,.23.08.48.08.73a2.31,2.31,0,0,1-.08.73,1.8,1.8,0,0,1-.41.65c-.08.24-.33.4-.49.57a4.93,4.93,0,0,1-.65.32A2.28,2.28,0,0,1,253.51,242.55Z",
    transform: "translate(-118.64 -69.63)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.1,240.93a2.31,2.31,0,0,1-.08-.73,2.22,2.22,0,0,1,.08-.73,4.54,4.54,0,0,1,.32-.66,1.12,1.12,0,0,1,.58-.48,1.64,1.64,0,0,1,.64-.41,2.31,2.31,0,0,1,.73-.08,2.22,2.22,0,0,1,.73.08,5.12,5.12,0,0,1,.66.32,2,2,0,0,1,.56.57,3.68,3.68,0,0,1,.33.66,2.22,2.22,0,0,1,.08.73,2.31,2.31,0,0,1-.08.73,3.91,3.91,0,0,1-.33.65,2,2,0,0,1-.56.57,1.7,1.7,0,0,1-.66.32,2.22,2.22,0,0,1-.73.08,2.31,2.31,0,0,1-.73-.08,1.61,1.61,0,0,1-.64-.32,2.1,2.1,0,0,1-.58-.57,4.93,4.93,0,0,1-.32-.65Z",
    transform: "translate(-118.64 -69.63)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.65,249.63a2.19,2.19,0,0,1,1.38-.5c.25,0,.49.09.73.09a5.12,5.12,0,0,1,.66.32,1.9,1.9,0,0,1,.56.57,2.11,2.11,0,0,1,.41,1.39,1.86,1.86,0,0,1-.08.73,1.5,1.5,0,0,1-.33.64,1.79,1.79,0,0,1-.56.57,2.21,2.21,0,0,1-1.39.49,2.46,2.46,0,0,1-.73-.16,2.35,2.35,0,0,1-.65-.33c-.16-.16-.41-.32-.49-.48a2.67,2.67,0,0,1-.48-1.46,2.31,2.31,0,0,1,.08-.74c.08-.24.24-.4.32-.65a3.13,3.13,0,0,1,.57-.48Z",
    transform: "translate(-118.64 -69.63)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.93,237.1l.24.25a.91.91,0,0,1,.09.81c0,.08-.09.17-.09.25s-.16.16-.24.16a1,1,0,0,1-.81.17c-.09,0-.17-.08-.25-.17a.17.17,0,0,1-.16-.16,1,1,0,0,1-.16-.81c.08-.08.08-.17.16-.25s.08-.16.16-.25a1.05,1.05,0,0,1,.81-.08C259.76,237,259.85,237.1,259.93,237.1Z",
    transform: "translate(-118.64 -69.63)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.25,245.39c0,.09-.08.17-.08.25l-.25.25a.93.93,0,0,1-.81.08c-.08,0-.16-.08-.24-.08s-.08-.17-.16-.25a.93.93,0,0,1-.16-.81c.08-.08.08-.16.16-.25s.08-.16.16-.16a1,1,0,0,1,.82-.16c.07.08.15.08.23.16s.17.08.25.16A1,1,0,0,1,270.25,245.39Z",
    transform: "translate(-118.64 -69.63)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.62,257.75h-.25c-.16-.08-.24-.08-.32-.16s-.08-.08-.16-.17a1,1,0,0,1-.16-.81c.08-.08.08-.16.16-.24s.16-.16.16-.24a1,1,0,0,1,.82-.08.31.31,0,0,1,.23.08c.08.08.17.15.25.24a.74.74,0,0,1,.08.81.29.29,0,0,1-.08.24c-.08.09-.17.17-.25.17-.07.16-.32.16-.48.16Z",
    transform: "translate(-118.64 -69.63)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.37,257.18v-.57c.08-.08.08-.16.16-.24s.08-.16.17-.16a1,1,0,0,1,.81-.16c.08,0,.16.08.24.16a.37.37,0,0,1,.25.16.94.94,0,0,1,.08.81c0,.08-.08.16-.08.24s-.16.17-.25.17a.87.87,0,0,1-.81.16c-.08,0-.16-.08-.24-.16s-.09-.08-.17-.17-.08-.16-.16-.24Z",
    transform: "translate(-118.64 -69.63)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.87,244.42a1,1,0,0,1,.82-.16c.08.08.16.08.24.16s.17.08.25.16a1,1,0,0,1,.08.81c0,.09-.08.17-.08.25l-.25.25a.94.94,0,0,1-.81.08.32.32,0,0,1-.25-.08c-.08-.08-.08-.17-.16-.25a1,1,0,0,1-.15-.81c.07-.08.07-.16.15-.25Z",
    transform: "translate(-118.64 -69.63)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.63,239.22c-.41-.89-.82-1.7-.82-1.7l6.59-3.66a17.54,17.54,0,0,1,1,1.95c.33.81.65,1.54.9,2.35a5.38,5.38,0,0,1,.33,1c.24.81.48,1.54.64,2.36.25,1.13.41,2.19.41,2.19l-7.56.89-.32-1.78a10.33,10.33,0,0,1-.41-1.46,5.31,5.31,0,0,0-.24-.66c-.17-.48-.33-1-.49-1.46Z",
    transform: "translate(-118.64 -69.63)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.05,266.61c.65-.57,1.29-1.22,1.29-1.22l5.61,5.12s-.81.81-1.62,1.54c-.65.58-1.3,1.06-1.95,1.55-.25.24-.57.41-.81.65-.65.4-1.39.9-2.12,1.3a17.87,17.87,0,0,1-1.95,1.05l-3.08-6.9s.81-.41,1.54-.89c.49-.25.89-.58,1.3-.81a3.12,3.12,0,0,1,.57-.42l1.22-1Z",
    transform: "translate(-118.64 -69.63)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.92,268.81c.74.48,1.55.89,1.55.89l-3.17,6.9s-1-.48-2-1.05c-.65-.4-1.38-.9-2-1.3a7.34,7.34,0,0,1-.82-.65c-.65-.49-1.29-1-1.94-1.55-.82-.73-1.63-1.54-1.63-1.54l5.61-5.12s.64.65,1.3,1.22l1.21,1c.17.17.41.25.58.42a8.3,8.3,0,0,0,1.29.81Z",
    transform: "translate(-118.64 -69.63)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M236.12,242.8c-.25.89-.41,1.78-.41,1.78l-7.47-.89s.16-1.06.4-2.19c.16-.82.41-1.55.65-2.36l.24-1c.33-.81.66-1.54,1-2.35.41-1,.89-1.95.89-1.95L238,237.6s-.41.81-.74,1.62c-.16.48-.32,1-.49,1.46-.07.16-.15.41-.23.66A8.6,8.6,0,0,0,236.12,242.8Z",
    transform: "translate(-118.64 -69.63)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.57,224.43c-.89.08-1.86.24-1.86.24l-1.47-7.39a15.66,15.66,0,0,1,2.19-.33c.82-.08,1.63-.08,2.52-.16h1c.81.08,1.62.08,2.52.16a18.48,18.48,0,0,1,2.19.33l-1.54,7.39s-.89-.16-1.79-.24h-3.74Z",
    transform: "translate(-118.64 -69.63)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.32,253.85A26.54,26.54,0,0,1,228,251l7.56-.73s.08,1.23.24,2.44c.16.73.33,1.55.57,2.28a14.9,14.9,0,0,0,.57,1.62,17.23,17.23,0,0,0,.81,2.12c.57,1.14,1.22,2.19,1.22,2.19l-6.5,3.82s-.73-1.22-1.38-2.52a17.87,17.87,0,0,1-1.22-2.84c-.33-.82-.57-1.63-.81-2.44-.33-1.06-.5-2-.73-3.09Z",
    transform: "translate(-118.64 -69.63)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M244.65,220.52a16.13,16.13,0,0,1,2.6-1.21l3,6.91s-1.14.49-2.28,1.05L246,228.5a15.21,15.21,0,0,0-1.38,1,16.49,16.49,0,0,0-1.79,1.54,14.41,14.41,0,0,0-1.62,1.79l-5.69-5a25.45,25.45,0,0,1,1.95-2,27.63,27.63,0,0,1,2.35-2.11c.65-.49,1.39-1.06,2.12-1.55a22.72,22.72,0,0,1,2.68-1.55Z",
    transform: "translate(-118.64 -69.63)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M281.39,225.73c1,1,1.95,2,1.95,2l-5.69,5a19.41,19.41,0,0,0-1.71-1.79,16.52,16.52,0,0,0-1.7-1.54c-.49-.33-1-.66-1.47-1a18.87,18.87,0,0,0-1.95-1.23c-1.06-.56-2.19-1.05-2.19-1.05l3-6.91a21,21,0,0,1,2.61,1.21c.89.5,1.79,1,2.68,1.55.73.49,1.46,1.06,2.11,1.55.81.64,1.55,1.38,2.36,2.11Z",
    transform: "translate(-118.64 -69.63)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.81,262.22c-.66,1.3-1.39,2.52-1.39,2.52l-6.58-3.82a13.4,13.4,0,0,0,1.22-2.19,16,16,0,0,0,.89-2.12,13.12,13.12,0,0,0,.58-1.62c.15-.73.4-1.55.48-2.28a20.31,20.31,0,0,0,.33-2.44l7.55.73s-.15,1.47-.4,2.85c-.16,1.06-.41,2-.65,3.09-.24.81-.49,1.62-.82,2.44-.4,1-.81,1.95-1.21,2.84Z",
    transform: "translate(-118.64 -69.63)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.05,279.61a27.63,27.63,0,0,1-2.84-.48l1.63-7.4s1.21.24,2.43.41a22,22,0,0,0,2.28.24h1.79c.73-.08,1.46-.08,2.27-.24,1.22-.17,2.44-.41,2.44-.41l1.63,7.4a28.13,28.13,0,0,1-2.85.48c-1.06.17-2,.25-3.09.33h-2.6c-1.06-.08-2.12-.16-3.09-.33Z",
    transform: "translate(-118.64 -69.63)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 135.6,
    y1: 147.65,
    x2: 134.54,
    y2: 142.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 168.76,
    y1: 164.23,
    x2: 173.23,
    y2: 161.63
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 163.31,
    y1: 200.88,
    x2: 167.05,
    y2: 204.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 126.66,
    y1: 206.97,
    x2: 124.54,
    y2: 211.69
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 109.6,
    y1: 174.06,
    x2: 104.47,
    y2: 173.49
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 146,
    y1: 147.65,
    x2: 147.06,
    y2: 142.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 172.01,
    y1: 174.06,
    x2: 177.13,
    y2: 173.49
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 154.86,
    y1: 206.97,
    x2: 156.97,
    y2: 211.69
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 118.29,
    y1: 200.88,
    x2: 114.47,
    y2: 204.38
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 112.76,
    y1: 164.23,
    x2: 108.29,
    y2: 161.63
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 132.43,
    y1: 214.45,
    x2: 133.56,
    y2: 209.49
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 104.22,
    y1: 181.86,
    x2: 109.35,
    y2: 181.37
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 126.58,
    y1: 144.97,
    x2: 128.61,
    y2: 149.68
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 168.59,
    y1: 154.8,
    x2: 164.69,
    y2: 158.13
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 172.17,
    y1: 197.79,
    x2: 167.78,
    y2: 195.11
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 149.17,
    y1: 214.45,
    x2: 148.04,
    y2: 209.49
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 109.43,
    y1: 197.79,
    x2: 113.82,
    y2: 195.11
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 113.01,
    y1: 154.8,
    x2: 116.91,
    y2: 158.13
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 155.02,
    y1: 144.97,
    x2: 152.99,
    y2: 149.68
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 177.38,
    y1: 181.86,
    x2: 172.25,
    y2: 181.37
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 135.2,
    y1: 202.09,
    x2: 138.44,
    y2: 188.69
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 116.91,
    y1: 180.64,
    x2: 130.64,
    y2: 179.59
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 131.62,
    y1: 156.59,
    x2: 136.9,
    y2: 169.34
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 159.01,
    y1: 163.17,
    x2: 148.52,
    y2: 172.11
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 161.2,
    y1: 191.29,
    x2: 149.5,
    y2: 184.06
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 146.4,
    y1: 202.09,
    x2: 143.16,
    y2: 188.69
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 120.32,
    y1: 191.29,
    x2: 132.1,
    y2: 184.06
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 122.59,
    y1: 163.17,
    x2: 133.08,
    y2: 172.11
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 149.98,
    y1: 156.59,
    x2: 144.7,
    y2: 169.34
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 164.69,
    y1: 180.64,
    x2: 150.96,
    y2: 179.59
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "142.18 187.47 140.23 186.98 138.85 188.36 139.42 190.23 141.29 190.8 142.66 189.42 142.18 187.47"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.92 182.75 132.83 180.81 131.05 179.91 129.42 180.97 129.5 182.91 131.29 183.81 132.92 182.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.54 172.52 136.41 171.78 136.66 169.84 135.2 168.61 133.33 169.34 133 171.3 134.54 172.52"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "144.78 170.89 146 172.44 147.95 172.11 148.68 170.24 147.46 168.7 145.51 169.03 144.78 170.89"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "149.5 180.15 148.44 181.78 149.33 183.57 151.28 183.65 152.34 182.02 151.45 180.23 149.5 180.15"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M255.71,224.67l2,8.29a2.59,2.59,0,0,0,.4,1.14,3.44,3.44,0,0,0,.81,1.38.73.73,0,0,0,1,0,4.3,4.3,0,0,0,.81-1.38c.16-.32.25-.73.41-1.14l2-8.29",
    transform: "translate(-118.64 -69.63)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280.81,237.52l-7.31,4.55a3.61,3.61,0,0,0-.89.64,4.65,4.65,0,0,0-1.06,1.23.76.76,0,0,0,.33.89c.32.32,1,.32,1.54.4a5.43,5.43,0,0,0,1.14,0l8.53-.65",
    transform: "translate(-118.64 -69.63)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M276.34,265.39l-6.5-5.52-1-.74a3.76,3.76,0,0,0-1.46-.57,1,1,0,0,0-.82.57,5.71,5.71,0,0,0,.17,1.55,4.67,4.67,0,0,0,.32,1.13l3.34,7.89",
    transform: "translate(-118.64 -69.63)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M248.47,269.7l3.25-7.89a4.71,4.71,0,0,0,.41-1.13,3.49,3.49,0,0,0,.08-1.55.79.79,0,0,0-.74-.57,4.65,4.65,0,0,0-1.54.57,7.76,7.76,0,0,0-.89.74l-6.5,5.52",
    transform: "translate(-118.64 -69.63)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.71,244.58l8.53.65a6.22,6.22,0,0,0,1.22,0,3.11,3.11,0,0,0,1.54-.4.89.89,0,0,0,.33-.89,4.6,4.6,0,0,0-1.05-1.23,6.83,6.83,0,0,0-1-.64L238,237.52",
    transform: "translate(-118.64 -69.63)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.44,241.82a6.55,6.55,0,1,1,0,13.09,6.55,6.55,0,1,1,0-13.09Z",
    transform: "translate(-118.64 -69.63)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M262.37,253.44a1.51,1.51,0,0,0,.4-.32,5.38,5.38,0,0,0,1.39-1.3,10.32,10.32,0,0,0,.81-1.63,7.36,7.36,0,0,0,.24-1.79,6.38,6.38,0,0,0-.24-1.78,10.32,10.32,0,0,0-.81-1.63,5.38,5.38,0,0,0-1.39-1.3.82.82,0,0,0-.4-.33v1a3.58,3.58,0,0,1,1.05,1.14,4.39,4.39,0,0,1,.74,1.38,5.12,5.12,0,0,1,.24,1.54,4.9,4.9,0,0,1-.24,1.46,4.73,4.73,0,0,1-.74,1.47,4.88,4.88,0,0,1-1.05,1.14v1Zm0-2.11v-1.87l1-2.28a2.52,2.52,0,0,1,.16.74,4.1,4.1,0,0,1-.32,2.19,2.43,2.43,0,0,1-.41.65,2.47,2.47,0,0,1-.4.57Zm0-4.38v-1.47l.16.16h0c.08.08.16.25.24.33Zm-2.93,7.31a4.16,4.16,0,0,0,1.71-.33,3.76,3.76,0,0,0,1.22-.49v-1h0a6.1,6.1,0,0,1-1.47.73,9,9,0,0,1-1.46.17v.89Zm2.93-10.9a8.77,8.77,0,0,0-1.22-.56,6,6,0,0,0-1.71-.25v.81a4.35,4.35,0,0,1,1.46.25,6.1,6.1,0,0,1,1.47.73h0v-1Zm0,2.12V247l-1.47,3.41-.89-1.87h-.57v-.25H260l1.54-3.41a.92.92,0,0,1,.33.25,1,1,0,0,1,.33.23l.16.17Zm0,4-1.22,2.68h0c.25-.08.4-.24.65-.32s.41-.32.57-.49v-1.87Zm-2.93,3.09v-2.92l1.14,2.76a5.59,5.59,0,0,1-1.14.16Zm0-5.37v-2.92a2.89,2.89,0,0,1,.82.08h0c.16,0,.24.08.4.08l-1.22,2.76Zm-1.78-4.38c-.41.16-.74.32-1.14.49v1.05a5.71,5.71,0,0,1,1.37-.73h0a4.62,4.62,0,0,1,1.55-.25h0v-.81a6,6,0,0,0-1.78.25Zm-1.14,10.64a3.23,3.23,0,0,0,1.14.49,4.21,4.21,0,0,0,1.78.33v-.89h0a9.31,9.31,0,0,1-1.55-.17,4.53,4.53,0,0,1-1.37-.73v1Zm2.92-9.18v2.92l-1.14-2.76a2.63,2.63,0,0,1,1.14-.16Zm0,4h-.57l-1.54-3.41a4.53,4.53,0,0,0-.81.56h0v1.47l1.54,3.5.81-1.87h.57v-.25Zm0,1.47v2.84a2.79,2.79,0,0,1-.81-.08h0c-.08,0-.24-.08-.33-.08l1.14-2.68Zm-2.92,1.62v-2l1.22,2.85c-.25-.17-.41-.25-.66-.41S256.68,251.5,256.52,251.33Zm0-8a2,2,0,0,1-.5.32,7,7,0,0,0-1.29,1.38,5.91,5.91,0,0,0-.81,1.63,6,6,0,0,0-.25,1.78,6.94,6.94,0,0,0,.25,1.79,5.91,5.91,0,0,0,.81,1.63,5,5,0,0,0,1.29,1.3c.17.08.33.25.5.32v-1h0a8.19,8.19,0,0,1-1.14-1.14,4.71,4.71,0,0,1-.73-1.47,9,9,0,0,1-.17-1.46,9.18,9.18,0,0,1,.17-1.54,4.36,4.36,0,0,1,.73-1.38,5.13,5.13,0,0,1,1.14-1.14h0v-1.05Zm0,2.1v1.47l-.41-.89a3.09,3.09,0,0,1,.41-.58Zm0,4v2h0a4.59,4.59,0,0,1-.5-.65c-.15-.16-.23-.41-.4-.65l-.24-.73a4.34,4.34,0,0,1,.16-2.28h0Z",
    transform: "translate(-118.64 -69.63)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M257.66,242.8a10.43,10.43,0,0,0-1.64.81,7,7,0,0,0-1.29,1.38,5.91,5.91,0,0,0-.81,1.63,6,6,0,0,0-.25,1.78,6.94,6.94,0,0,0,.25,1.79,5.91,5.91,0,0,0,.81,1.63,5,5,0,0,0,1.29,1.3,4.5,4.5,0,0,0,1.64.81,4.21,4.21,0,0,0,1.78.33,4.16,4.16,0,0,0,1.71-.33,4.34,4.34,0,0,0,1.62-.81,5.38,5.38,0,0,0,1.39-1.3,10.32,10.32,0,0,0,.81-1.63,7.36,7.36,0,0,0,.24-1.79,6.38,6.38,0,0,0-.24-1.78,10.32,10.32,0,0,0-.81-1.63,5.38,5.38,0,0,0-1.39-1.3,6.24,6.24,0,0,0-1.62-.89,6.21,6.21,0,0,0-3.49,0m.23.81a4.53,4.53,0,0,0-1.37.73,5.13,5.13,0,0,0-1.14,1.14,4.36,4.36,0,0,0-.73,1.38,9.18,9.18,0,0,0-.17,1.54,9,9,0,0,0,.17,1.46,4.71,4.71,0,0,0,.73,1.47,8.19,8.19,0,0,0,1.14,1.14,4.53,4.53,0,0,0,1.37.73,9.31,9.31,0,0,0,1.55.17,9,9,0,0,0,1.46-.17,6.1,6.1,0,0,0,1.47-.73,4.88,4.88,0,0,0,1.05-1.14,4.73,4.73,0,0,0,.74-1.47,4.9,4.9,0,0,0,.24-1.46,5.12,5.12,0,0,0-.24-1.54,4.39,4.39,0,0,0-.74-1.38,3.58,3.58,0,0,0-1.05-1.14,6.1,6.1,0,0,0-1.47-.73,4.35,4.35,0,0,0-1.46-.25,4.62,4.62,0,0,0-1.55.25m4.64,2c-.08-.08-.24-.16-.32-.33a1,1,0,0,0-.33-.23.92.92,0,0,0-.33-.25L260,248.24h-1.14l-1.54-3.41a4.53,4.53,0,0,0-.81.56,3.09,3.09,0,0,0-.41.58l1.95,4.39.81-1.87H260l.89,1.87,1.87-4.39c-.08-.08-.16-.25-.24-.33m-1.38,6.5c.25-.08.4-.24.65-.32s.41-.32.57-.49a2.47,2.47,0,0,0,.4-.57,2.43,2.43,0,0,0,.41-.65,4.1,4.1,0,0,0,.32-2.19,2.52,2.52,0,0,0-.16-.74l-2.19,5m-2.52.33a5.34,5.34,0,0,0,1.95-.08l-1.14-2.76-1.14,2.76c.09,0,.25.08.33.08M255.54,247a4.34,4.34,0,0,0-.16,2.28l.24.73c.17.24.25.49.4.65a4.59,4.59,0,0,0,.5.65c.16.17.4.32.56.49s.41.24.66.41l-2.2-5.21m4.72-2.68a3.28,3.28,0,0,0-2,.08l1.14,2.76,1.22-2.76c-.16,0-.24-.08-.4-.08Z",
    transform: "translate(-118.64 -69.63)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.35,218.66a36.19,36.19,0,0,1,8.29,8.28,34.19,34.19,0,0,1,5.21,10.33,35.53,35.53,0,0,1,0,22.27A36.72,36.72,0,0,1,716,283.35a37.08,37.08,0,0,1-22.26,0,38.57,38.57,0,0,1-10.33-5.2,36.84,36.84,0,0,1-8.29-8.29,39,39,0,0,1-5.2-10.32,37.32,37.32,0,0,1,0-22.27,36.57,36.57,0,0,1,13.49-18.61,36.36,36.36,0,0,1,10.33-5.2,35.5,35.5,0,0,1,22.26,0A34.11,34.11,0,0,1,726.35,218.66Z",
    transform: "translate(-118.64 -69.63)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706.28,256.53a3.82,3.82,0,0,1,.57.57,2.45,2.45,0,0,1,.32.65,2.15,2.15,0,0,1,0,1.46,1.7,1.7,0,0,1-.32.66,1.79,1.79,0,0,1-.57.56,1.48,1.48,0,0,1-.65.33,2.28,2.28,0,0,1-1.46,0,2.22,2.22,0,0,1-.65-.33,3.73,3.73,0,0,1-.57-.56,6.73,6.73,0,0,1-.33-.66,2.28,2.28,0,0,1,0-1.46c.09-.24.25-.41.33-.65l.57-.57c.24-.08.41-.25.65-.32a2.28,2.28,0,0,1,1.46,0,3.58,3.58,0,0,1,.65.32Z",
    transform: "translate(-118.64 -69.63)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.59,252.23a1.76,1.76,0,0,1-.41.64c-.08.25-.33.41-.48.57a2.55,2.55,0,0,1-.66.33,2.28,2.28,0,0,1-1.46,0,1.6,1.6,0,0,1-.65-.33,1.82,1.82,0,0,1-.57-.57,1.39,1.39,0,0,1-.32-.64,2.18,2.18,0,0,1,0-1.47,1.42,1.42,0,0,1,.32-.65,1.94,1.94,0,0,1,.57-.57,4.38,4.38,0,0,1,.65-.32,2.15,2.15,0,0,1,1.46,0,5,5,0,0,1,1.22.89c.08.25.25.41.33.65A2.46,2.46,0,0,1,697.59,252.23Z",
    transform: "translate(-118.64 -69.63)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M699,242.55a2.25,2.25,0,0,1-.73-.08,3.94,3.94,0,0,1-.65-.32,2.1,2.1,0,0,1-.58-.57,4,4,0,0,1-.31-.65,2.06,2.06,0,0,1-.09-.73,2,2,0,0,1,.09-.73,1.53,1.53,0,0,1,.4-.66c.08-.24.32-.4.49-.57a3.94,3.94,0,0,1,.65-.32,2.25,2.25,0,0,1,.73-.08,2.28,2.28,0,0,1,.73.08c.24.08.49.24.73.32a4.94,4.94,0,0,1,.49.57,1.78,1.78,0,0,1,.33.66,2.22,2.22,0,0,1,.08.73,2.31,2.31,0,0,1-.08.73,1.81,1.81,0,0,1-.33.65,2.21,2.21,0,0,1-.57.57,4.93,4.93,0,0,1-.65.32,2.28,2.28,0,0,1-.73.08Z",
    transform: "translate(-118.64 -69.63)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M708.64,240.93a2.46,2.46,0,0,1-.16-.73,2.27,2.27,0,0,1,.16-.73,1.63,1.63,0,0,1,.32-.66,1.46,1.46,0,0,1,.49-.48,2.59,2.59,0,0,1,.65-.41,2.56,2.56,0,0,1,.81-.08,2.25,2.25,0,0,1,.73.08c.25.08.41.24.66.32a4.1,4.1,0,0,1,.48.57,1.52,1.52,0,0,1,.33.66,2.29,2.29,0,0,1,.17.73,2.49,2.49,0,0,1-.17.73,1.54,1.54,0,0,1-.33.65,4.1,4.1,0,0,1-.48.57,2.5,2.5,0,0,1-.66.32,2.76,2.76,0,0,1-.81.08,2.31,2.31,0,0,1-.73-.08,2.45,2.45,0,0,1-.65-.32,4.94,4.94,0,0,1-.49-.57,1.65,1.65,0,0,1-.32-.65Z",
    transform: "translate(-118.64 -69.63)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M713.11,249.63a2.41,2.41,0,0,1,1.46-.5,2,2,0,0,1,.73.09,5.12,5.12,0,0,0,.66.32,4.21,4.21,0,0,1,.48.57,2.19,2.19,0,0,1,.49,1.39,2,2,0,0,1-.16.73,1,1,0,0,1-.33.64c-.08.25-.33.41-.48.57a2.43,2.43,0,0,1-1.47.49,1.55,1.55,0,0,1-.65-.16,3,3,0,0,1-.73-.33l-.49-.48a2.67,2.67,0,0,1-.48-1.46,2.39,2.39,0,0,1,.16-.74,2.6,2.6,0,0,1,.32-.65l.49-.48Z",
    transform: "translate(-118.64 -69.63)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M705.47,237.1c.08.09.08.17.16.25a.93.93,0,0,1,.17.81c-.08.08-.08.17-.17.25s-.08.16-.16.16a1,1,0,0,1-.81.17c-.08,0-.17-.08-.25-.17s-.16-.08-.24-.16a1,1,0,0,1-.08-.81c0-.08.08-.17.08-.25l.24-.25a1,1,0,0,1,.81-.08c.09,0,.17.08.25.08Z",
    transform: "translate(-118.64 -69.63)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M715.79,245.39c-.08.09-.08.17-.16.25s-.08.17-.16.25a1,1,0,0,1-.82.08c-.08,0-.16-.08-.24-.08a2.77,2.77,0,0,1-.24-.25.94.94,0,0,1-.08-.81c0-.08.08-.16.08-.25s.15-.16.24-.16a1,1,0,0,1,.81-.16c.08.08.16.08.25.16a.17.17,0,0,1,.16.16,1,1,0,0,1,.16.81Z",
    transform: "translate(-118.64 -69.63)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M711.08,257.75h-.25c-.08-.08-.16-.08-.24-.16s-.16-.08-.24-.17a.9.9,0,0,1-.08-.81c0-.08.08-.16.08-.24s.16-.16.24-.24a.94.94,0,0,1,.81-.08c.08,0,.16.08.24.08s.17.15.17.24a1,1,0,0,1,.16.81c-.08.08-.08.16-.16.24a.18.18,0,0,1-.17.17.67.67,0,0,1-.56.16Z",
    transform: "translate(-118.64 -69.63)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697.91,257.18a.71.71,0,0,1,0-.57c0-.08.08-.16.08-.24a.4.4,0,0,1,.25-.16.94.94,0,0,1,.81-.16c.08,0,.16.08.24.16s.09.07.17.16a1,1,0,0,1,.15.81c-.07.08-.07.16-.15.24a.18.18,0,0,1-.17.17,1,1,0,0,1-.81.16c-.08,0-.16-.08-.24-.16s-.17-.08-.25-.17-.08-.16-.08-.24Z",
    transform: "translate(-118.64 -69.63)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M694.42,244.42a1,1,0,0,1,.81-.16c.08.08.16.08.24.16l.17.16a1,1,0,0,1,.16.81c-.08.09-.08.17-.16.25s-.08.17-.17.25a1,1,0,0,1-.81.08.29.29,0,0,1-.24-.08l-.25-.25a.94.94,0,0,1-.08-.81c0-.08.08-.16.08-.25s.16-.08.25-.16Z",
    transform: "translate(-118.64 -69.63)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M727.09,239.22c-.33-.89-.74-1.7-.74-1.7l6.59-3.66s.49,1,1,1.95c.33.81.57,1.54.9,2.35l.24,1c.24.81.49,1.54.65,2.36.25,1.13.41,2.19.41,2.19l-7.48.89s-.16-.89-.41-1.78a9.59,9.59,0,0,0-.4-1.46,2.69,2.69,0,0,1-.16-.66,9.78,9.78,0,0,1-.57-1.46Z",
    transform: "translate(-118.64 -69.63)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M720.51,266.61c.65-.57,1.29-1.22,1.29-1.22l5.61,5.12s-.81.81-1.62,1.54a16.36,16.36,0,0,1-1.87,1.55l-.89.65c-.65.4-1.39.9-2,1.3-1,.57-2,1.05-2,1.05l-3.16-6.9s.81-.41,1.62-.89c.4-.25.81-.58,1.22-.81a4,4,0,0,0,.57-.42l1.22-1Z",
    transform: "translate(-118.64 -69.63)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M692.38,268.81c.81.48,1.63.89,1.63.89l-3.17,6.9s-1-.48-2-1.05c-.73-.4-1.38-.9-2.12-1.3-.23-.24-.56-.41-.81-.65-.65-.49-1.29-1-2-1.55-.81-.73-1.62-1.54-1.62-1.54l5.61-5.12a15.36,15.36,0,0,0,1.38,1.22,12.39,12.39,0,0,0,1.13,1,3.64,3.64,0,0,1,.58.42c.4.23.89.56,1.29.81Z",
    transform: "translate(-118.64 -69.63)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M681.57,242.8l-.32,1.78-7.56-.89s.16-1.06.41-2.19c.16-.82.41-1.55.65-2.36a4.67,4.67,0,0,1,.32-1c.25-.81.58-1.54.9-2.35a19.77,19.77,0,0,1,1-1.95l6.59,3.66s-.41.81-.82,1.7c-.16.48-.32,1-.49,1.46-.08.16-.15.41-.24.66A9.14,9.14,0,0,1,681.57,242.8Z",
    transform: "translate(-118.64 -69.63)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M703,224.43c-.89.08-1.78.24-1.78.24l-1.55-7.39a18.48,18.48,0,0,1,2.19-.33c.9-.08,1.71-.08,2.52-.16h1c.89.08,1.7.08,2.51.16a15.65,15.65,0,0,1,2.2.33l-1.46,7.39s-1-.16-1.87-.24H703Z",
    transform: "translate(-118.64 -69.63)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M673.85,253.85c-.24-1.38-.4-2.85-.4-2.85l7.56-.73a21.54,21.54,0,0,0,.32,2.44,23.19,23.19,0,0,0,.49,2.28,11.59,11.59,0,0,0,.57,1.62,17.49,17.49,0,0,0,.89,2.12c.57,1.14,1.22,2.19,1.22,2.19l-6.58,3.82s-.73-1.22-1.38-2.52c-.41-.89-.81-1.87-1.22-2.84-.33-.82-.57-1.63-.81-2.44-.25-1.06-.5-2-.66-3.09Z",
    transform: "translate(-118.64 -69.63)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M690.11,220.52a20.56,20.56,0,0,1,2.6-1.21l3,6.91s-1.14.49-2.2,1.05a18.87,18.87,0,0,0-1.95,1.23c-.48.31-1,.64-1.46,1a14.67,14.67,0,0,0-1.7,1.54,19.41,19.41,0,0,0-1.71,1.79l-5.69-5s1-1.06,2-2c.81-.73,1.54-1.47,2.35-2.11s1.39-1.06,2.12-1.55C688.32,221.5,689.22,221,690.11,220.52Z",
    transform: "translate(-118.64 -69.63)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M726.85,225.73a27.74,27.74,0,0,1,1.95,2l-5.61,5a19.41,19.41,0,0,0-1.71-1.79,16.49,16.49,0,0,0-1.79-1.54,13.93,13.93,0,0,0-1.38-1l-1.95-1.23c-1.14-.56-2.27-1.05-2.27-1.05l3-6.91a16.13,16.13,0,0,1,2.6,1.21,23.72,23.72,0,0,1,2.69,1.55,19.3,19.3,0,0,1,2.1,1.55,27.9,27.9,0,0,1,2.37,2.11Z",
    transform: "translate(-118.64 -69.63)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M733.27,262.22c-.66,1.3-1.39,2.52-1.39,2.52l-6.5-3.82s.66-1.05,1.22-2.19a15.76,15.76,0,0,0,.81-2.12A11.59,11.59,0,0,0,728,255c.24-.73.41-1.55.57-2.28.17-1.21.25-2.44.25-2.44l7.55.73a28.12,28.12,0,0,1-.32,2.85c-.25,1.06-.41,2-.74,3.09-.24.81-.48,1.62-.81,2.44A17.82,17.82,0,0,1,733.27,262.22Z",
    transform: "translate(-118.64 -69.63)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M700.51,279.61a27.63,27.63,0,0,1-2.84-.48l1.62-7.4s1.22.24,2.44.41c.81.16,1.54.16,2.28.24h1.79a21.85,21.85,0,0,0,2.27-.24c1.22-.17,2.44-.41,2.44-.41l1.63,7.4a28.13,28.13,0,0,1-2.85.48c-1,.17-2,.25-3.09.33h-2.6c-1-.08-2-.16-3.09-.33Z",
    transform: "translate(-118.64 -69.63)"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 581.06,
    y1: 147.65,
    x2: 580.08,
    y2: 142.6
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 614.3,
    y1: 164.23,
    x2: 618.77,
    y2: 161.63
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 608.77,
    y1: 200.88,
    x2: 612.59,
    y2: 204.38
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 572.2,
    y1: 206.97,
    x2: 570.08,
    y2: 211.69
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 555.05,
    y1: 174.06,
    x2: 549.93,
    y2: 173.49
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 591.46,
    y1: 147.65,
    x2: 592.52,
    y2: 142.6
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 617.46,
    y1: 174.06,
    x2: 622.59,
    y2: 173.49
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 600.4,
    y1: 206.97,
    x2: 602.52,
    y2: 211.69
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 563.75,
    y1: 200.88,
    x2: 560.01,
    y2: 204.38
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 558.3,
    y1: 164.23,
    x2: 553.83,
    y2: 161.63
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 577.89,
    y1: 214.45,
    x2: 579.02,
    y2: 209.49
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 549.68,
    y1: 181.86,
    x2: 554.81,
    y2: 181.37
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 572.04,
    y1: 144.97,
    x2: 574.07,
    y2: 149.68
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 614.05,
    y1: 154.8,
    x2: 610.15,
    y2: 158.13
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 617.71,
    y1: 197.79,
    x2: 613.24,
    y2: 195.11
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 594.71,
    y1: 214.45,
    x2: 593.57,
    y2: 209.49
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 554.89,
    y1: 197.79,
    x2: 559.28,
    y2: 195.11
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 558.55,
    y1: 154.8,
    x2: 562.36,
    y2: 158.13
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 600.48,
    y1: 144.97,
    x2: 598.45,
    y2: 149.68
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 622.83,
    y1: 181.86,
    x2: 617.71,
    y2: 181.37
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 580.65,
    y1: 202.09,
    x2: 583.9,
    y2: 188.69
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 562.36,
    y1: 180.64,
    x2: 576.1,
    y2: 179.59
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 577.07,
    y1: 156.59,
    x2: 582.36,
    y2: 169.34
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 604.54,
    y1: 163.17,
    x2: 594.06,
    y2: 172.11
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 606.74,
    y1: 191.29,
    x2: 594.95,
    y2: 184.06
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 591.86,
    y1: 202.09,
    x2: 588.7,
    y2: 188.69
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 565.86,
    y1: 191.29,
    x2: 577.56,
    y2: 184.06
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 568.05,
    y1: 163.17,
    x2: 578.54,
    y2: 172.11
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 595.44,
    y1: 156.59,
    x2: 590.16,
    y2: 169.34
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 610.15,
    y1: 180.64,
    x2: 596.41,
    y2: 179.59
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "587.64 187.47 585.77 186.98 584.39 188.36 584.88 190.23 586.75 190.8 588.21 189.42 587.64 187.47"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "578.37 182.75 578.29 180.81 576.59 179.91 574.88 180.97 574.96 182.91 576.75 183.81 578.37 182.75"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "580 172.52 581.87 171.78 582.2 169.84 580.65 168.61 578.78 169.34 578.46 171.3 580 172.52"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "590.24 170.89 591.54 172.44 593.5 172.11 594.14 170.24 592.92 168.7 590.97 169.03 590.24 170.89"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "595.04 180.15 593.9 181.78 594.79 183.57 596.82 183.65 597.88 182.02 596.99 180.23 595.04 180.15"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M701.25,224.67l2,8.29c.15.41.24.82.4,1.14a4.7,4.7,0,0,0,.81,1.38.73.73,0,0,0,1,0,3.22,3.22,0,0,0,.81-1.38,2.74,2.74,0,0,0,.41-1.14l2-8.29",
    transform: "translate(-118.64 -69.63)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M726.35,237.52,719,242c-.32.25-.65.49-1,.73-.4.41-.89.82-1,1.23a.74.74,0,0,0,.24.89,3.18,3.18,0,0,0,1.55.4,6.22,6.22,0,0,0,1.22,0l8.53-.65",
    transform: "translate(-118.64 -69.63)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M721.8,265.39l-6.5-5.52a8.73,8.73,0,0,0-.89-.74,4.65,4.65,0,0,0-1.54-.57.78.78,0,0,0-.73.57,3.35,3.35,0,0,0,.08,1.55,4.71,4.71,0,0,0,.4,1.13l3.26,7.89",
    transform: "translate(-118.64 -69.63)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M694,269.7l3.25-7.89a4.67,4.67,0,0,0,.33-1.13,5.25,5.25,0,0,0,.15-1.55,1,1,0,0,0-.81-.57,3.76,3.76,0,0,0-1.46.57l-1,.74-6.5,5.52",
    transform: "translate(-118.64 -69.63)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M681.25,244.58l8.53.65a5.43,5.43,0,0,0,1.14,0c.57-.08,1.22-.08,1.54-.4a.76.76,0,0,0,.33-.89,4.65,4.65,0,0,0-1.06-1.23,8.94,8.94,0,0,0-.89-.73l-7.31-4.46",
    transform: "translate(-118.64 -69.63)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M704.9,241.82a6.55,6.55,0,1,1-6.5,6.58,6.55,6.55,0,0,1,6.5-6.58Z",
    transform: "translate(-118.64 -69.63)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M707.83,253.44c.16-.07.32-.24.48-.32a6.73,6.73,0,0,0,1.31-1.3,6.21,6.21,0,0,0,.81-1.63,7.36,7.36,0,0,0,.24-1.79,6.38,6.38,0,0,0-.24-1.78,6.21,6.21,0,0,0-.81-1.63,7.08,7.08,0,0,0-1.31-1.38l-.48-.25v1a5.1,5.1,0,0,1,1.13,1.14,3,3,0,0,1,.66,1.38,5.12,5.12,0,0,1,.24,1.54,4.9,4.9,0,0,1-.24,1.46,3.32,3.32,0,0,1-.66,1.47,8.11,8.11,0,0,1-1.13,1.14v1Zm0-2.11v-1.87l1-2.28a2.37,2.37,0,0,1,.08.74,3.46,3.46,0,0,1-.32,2.19,4,4,0,0,1-.33.65c-.16.16-.32.41-.48.57Zm0-4.38v-1.47c.07,0,.07.08.16.16h0a1.17,1.17,0,0,1,.24.33Zm-2.93,7.31a6.11,6.11,0,0,0,1.79-.33,7.39,7.39,0,0,0,1.14-.49v-1h0a4.63,4.63,0,0,1-1.39.73,9.94,9.94,0,0,1-1.54.17v.89Zm2.93-10.9a8,8,0,0,0-1.14-.56,6.1,6.1,0,0,0-1.79-.25v.81a4.82,4.82,0,0,1,1.54.25,4.63,4.63,0,0,1,1.39.73h0v-1Zm0,2.12V247l-1.47,3.41-.89-1.87h-.57v-.25h.57l1.62-3.41c.08.08.25.16.33.25a1.23,1.23,0,0,0,.33.23c0,.08.08.08.08.17Zm0,4-1.22,2.68h0a5.64,5.64,0,0,0,.65-.32,3.61,3.61,0,0,0,.57-.49v-1.87Zm-2.93,3.09v-2.84l.09-.08,1.13,2.76a6.27,6.27,0,0,1-1.22.16Zm0-5.45v-2.84a3.47,3.47,0,0,1,.9.08h0c.08,0,.23.08.32.08L705,247.18Zm-1.7-4.3a11.46,11.46,0,0,0-1.14.49v1a7,7,0,0,1,1.38-.65h0a4.4,4.4,0,0,1,1.46-.25h0v-.81h0a5.83,5.83,0,0,0-1.7.25Zm-1.14,10.64a2.71,2.71,0,0,0,1.14.49,6,6,0,0,0,1.7.33h0v-.89h0a9.08,9.08,0,0,1-1.46-.17,4.46,4.46,0,0,1-1.38-.73v1Zm2.84-9.18v2.84l-1.14-2.68a3,3,0,0,1,1.14-.16Zm0,4h-.57l-1.54-3.41a4.06,4.06,0,0,0-.73.56h0v1.47l1.54,3.5.73-1.87h.57v-.25Zm0,1.47v2.84a2.28,2.28,0,0,1-.73-.08h0c-.16,0-.24-.08-.41-.08l1.14-2.68Zm-2.84,1.62v-2l1.21,2.76a1.72,1.72,0,0,1-.65-.32A3.5,3.5,0,0,1,702.06,251.33Zm0-8a2.15,2.15,0,0,1-.49.32,7.21,7.21,0,0,0-1.38,1.38,8.85,8.85,0,0,0-.81,1.63,6,6,0,0,0-.25,1.78,6.94,6.94,0,0,0,.25,1.79,8.85,8.85,0,0,0,.81,1.63,5.19,5.19,0,0,0,1.38,1.3c.16.08.32.25.49.32v-1H702a5.57,5.57,0,0,1-1.79-2.61,4.35,4.35,0,0,1-.25-1.46,4.56,4.56,0,0,1,.25-1.54,4.36,4.36,0,0,1,.73-1.38,3.5,3.5,0,0,1,1.06-1.14l.08-.08v-1Zm0,2.1v1.47l-.49-1,.49-.5Zm0,4v2H702a4.59,4.59,0,0,1-.5-.65,6.6,6.6,0,0,1-.32-.65,2.71,2.71,0,0,1-.24-.73A4.22,4.22,0,0,1,701,247h0Z",
    transform: "translate(-118.64 -69.63)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M703.2,242.8a9.9,9.9,0,0,0-1.63.81,7.21,7.21,0,0,0-1.38,1.38,8.85,8.85,0,0,0-.81,1.63,6,6,0,0,0-.25,1.78,6.94,6.94,0,0,0,.25,1.79,8.85,8.85,0,0,0,.81,1.63,5.19,5.19,0,0,0,1.38,1.3,4.38,4.38,0,0,0,1.63.81,6,6,0,0,0,1.7.33,6.64,6.64,0,0,0,1.79-.33,6,6,0,0,0,1.62-.81,6.73,6.73,0,0,0,1.31-1.3,6.21,6.21,0,0,0,.81-1.63,7.36,7.36,0,0,0,.24-1.79,6.38,6.38,0,0,0-.24-1.78,6.21,6.21,0,0,0-.81-1.63,7.08,7.08,0,0,0-1.31-1.38,9.8,9.8,0,0,0-1.62-.81,6.5,6.5,0,0,0-1.79-.25,5.83,5.83,0,0,0-1.7.25m.24.81a6,6,0,0,0-1.46.73,3.5,3.5,0,0,0-1.06,1.14,4.36,4.36,0,0,0-.73,1.38,4.56,4.56,0,0,0-.25,1.54,4.35,4.35,0,0,0,.25,1.46,5.57,5.57,0,0,0,1.79,2.61,6,6,0,0,0,1.46.73,9.08,9.08,0,0,0,1.46.17,9.94,9.94,0,0,0,1.54-.17,4.63,4.63,0,0,0,1.39-.73,8.11,8.11,0,0,0,1.13-1.14,3.32,3.32,0,0,0,.66-1.47,4.9,4.9,0,0,0,.24-1.46,5.12,5.12,0,0,0-.24-1.54,3,3,0,0,0-.66-1.38,5.1,5.1,0,0,0-1.13-1.14,4.63,4.63,0,0,0-1.39-.73,4.82,4.82,0,0,0-1.54-.25,4.4,4.4,0,0,0-1.46.25m4.55,2a.91.91,0,0,1-.24-.33,1.23,1.23,0,0,1-.33-.23c-.08-.09-.25-.17-.33-.25l-1.62,3.41h-1.14l-1.54-3.41a4.06,4.06,0,0,0-.73.56l-.49.5,2,4.47.73-1.87h1.14l.89,1.87,1.87-4.39a1.17,1.17,0,0,0-.24-.33m-1.38,6.5a5.64,5.64,0,0,0,.65-.32,3.61,3.61,0,0,0,.57-.49c.16-.16.32-.41.48-.57a4,4,0,0,0,.33-.65,3.46,3.46,0,0,0,.32-2.19,2.37,2.37,0,0,0-.08-.74l-2.27,5m-2.44.33a5.34,5.34,0,0,0,2-.08L705,249.63l-1.23,2.76c.17,0,.25.08.41.08M701,247a4.22,4.22,0,0,0-.08,2.28,2.71,2.71,0,0,0,.24.73,6.6,6.6,0,0,0,.32.65,4.59,4.59,0,0,0,.5.65c.24.17.4.32.64.49a1.72,1.72,0,0,0,.65.32L701,247m4.8-2.68a3.55,3.55,0,0,0-2,.08l1.23,2.76,1.13-2.76c-.09,0-.24-.08-.32-.08Z",
    transform: "translate(-118.64 -69.63)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M861,172.66a3.05,3.05,0,0,0,2-1.14,11.81,11.81,0,0,0,2.28-3.33,11.09,11.09,0,0,0,1.13-4.15,8,8,0,0,0-.57-3.09,70.13,70.13,0,0,0-2.76-7.31,3.18,3.18,0,0,0-1.3-1.71,13.2,13.2,0,0,0-4.15-1.14,49.37,49.37,0,0,0-5.93-.48c-4.31,0-8.61.24-12.92.41a25.33,25.33,0,0,0-3.58.24,3.93,3.93,0,0,0-1.38.32,8.67,8.67,0,0,0-1.38,1.14,15.47,15.47,0,0,0-2.11,2c-.9,1-1.63,2-2.45,3.08-1.7,2.36-3.41,4.71-5.19,7-3.58,4.87-7.15,9.75-7.15,9.75Z",
    transform: "translate(-118.64 -69.63)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M860.94,171l-42.1,1.47c2.68-3.66,5.45-7.32,8.13-11.06l2.93-3.9c.41-.48.73-1,1.14-1.46.24-.33.48-.57.73-.89s.57-.58.81-.81c.57-.5,1.14-1,1.63-1.47.08,0,.16-.08.32-.08a.37.37,0,0,1,.25-.16c.24-.08.48-.08.64-.16a25.4,25.4,0,0,1,2.6-.17c4.55-.16,9.1-.49,13.66-.41,1,0,2,.08,2.92.17a15.7,15.7,0,0,1,1.95.16c.65.08,1.31.25,2,.33s1,.24,1.62.32a2.2,2.2,0,0,1,1,.33v.08a1.67,1.67,0,0,1,.32.48c.33.65.65,1.31.9,1.95a14.21,14.21,0,0,0,.81,2c.49,1.37,1,2.76,1.38,4.22a7.89,7.89,0,0,1,.33,1.22,1.78,1.78,0,0,1,0,.65,7.44,7.44,0,0,1-.17,1.39,8.85,8.85,0,0,1-.4,1.37c-.33.66-.58,1.39-1,2a15.09,15.09,0,0,1-1.38,1.78l-.24.25c-.08.08-.16.08-.33.16a.62.62,0,0,1-.41.16Z",
    transform: "translate(-118.64 -69.63)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.55,195.74l21.13-.82a9.9,9.9,0,0,1,1.54,0,17.88,17.88,0,0,1,1.87.41l8.21,2.27",
    transform: "translate(-118.64 -69.63)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M740.66,200.13,793.32,196a15,15,0,0,0,6-1.62A12.16,12.16,0,0,0,803,190.7l12.6-16.5",
    transform: "translate(-118.64 -69.63)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M861.92,172.42s-.73-3.1-1.63-6.1c-1-3.58-2.11-7.16-3.33-10.65a10.35,10.35,0,0,0-.81-1.95c-1-1.62-2.19-3.33-2.19-3.33",
    transform: "translate(-118.64 -69.63)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M833,173.64s3.49-7.64,7.64-14.88a10.66,10.66,0,0,1,2.76-3.49,5.47,5.47,0,0,1,2.76-1.14,32.47,32.47,0,0,1,5.69-.33,55.54,55.54,0,0,1,7.4.33,21.43,21.43,0,0,1,4.55,1.06",
    transform: "translate(-118.64 -69.63)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M779.27,132.51s4.55,1.14,9.18,1.86c4.23.66,8.53,1,12.76,1.47,9.19,1.06,18.37,1.87,27.47,2.93,5.61.65,11.13,1.46,16.74,2.19a5.69,5.69,0,0,1,1.79.25c.41.16.57.73.89,1.14,1,1.21,2,2.43,3,3.81,1.46,2,2.85,4.23,2.85,4.23",
    transform: "translate(-118.64 -69.63)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M834,151.28s4-3.41,8.29-6.42a28.77,28.77,0,0,1,6.1-3.49A107.58,107.58,0,0,1,861,137.22",
    transform: "translate(-118.64 -69.63)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M867.94,196.15l-5.13-3.1a2.2,2.2,0,0,1-1-1.37,5.36,5.36,0,0,1,.16-2l1.47-6.83a6.74,6.74,0,0,0,.24-1.22,7.26,7.26,0,0,0-.16-1.38l-1.55-7.88",
    transform: "translate(-118.64 -69.63)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M869.07,196.79a6.18,6.18,0,0,0,1.14.5,3.63,3.63,0,0,0,1.3.16l4,.15",
    transform: "translate(-118.64 -69.63)"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 523.68,
    y1: 6.72,
    x2: 532.05,
    y2: 8.18
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519,145.27c85.66-3.33,171.32-4.55,171.32-4.55l8.13-11.87a14.4,14.4,0,0,0,2.52-5.28c.41-2.6.65-5.28-.65-7.07-2.44-3.26-6.18-5.77-10.24-7.81A231.74,231.74,0,0,0,658.09,96a339.31,339.31,0,0,0-37-8.7c-9.43-1.7-19-2.59-28.61-3.57-7.88-.74-15.69-1.39-23.57-1.63-14-.4-28-.73-42-.4-14.87.4-29.75,1.14-44.54,2.76a212.87,212.87,0,0,0-32.83,5.84,222.44,222.44,0,0,0-31.37,11.88c-11,5-21.54,11-32.1,16.9-8.14,4.55-15.93,9.51-23.81,14.55-4.48,2.92-8.87,5.93-13,9.18A34.66,34.66,0,0,0,343,148.6a25.19,25.19,0,0,0-3.41,5.61S429.22,148.69,519,145.27Z",
    transform: "translate(-118.64 -69.63)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M691.73,137.06l5.12-7.55a18.43,18.43,0,0,0,3.17-6.34,8.22,8.22,0,0,0-.32-5.78A16.22,16.22,0,0,0,693,111.3a173.48,173.48,0,0,0-28-12.19,328,328,0,0,0-44-10.81c-15.93-2.85-32.19-4.23-48.36-5.21-15.28-.89-30.56-1-45.84-.56-14.3.33-28.69,1-42.91,2.6C472.54,86.35,461.08,88,450,91a212.19,212.19,0,0,0-32.27,12.19c-11.13,5.12-21.69,11.38-32.43,17.39-7.8,4.48-15.44,9.35-23.07,14.23A152.08,152.08,0,0,0,349,144a41.58,41.58,0,0,0-6.33,6.5",
    transform: "translate(-118.64 -69.63)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M689.78,137.06l6.59-9.67a12.07,12.07,0,0,0,1.87-4c.48-1.87,1-3.73.33-5.11a14.1,14.1,0,0,0-6.11-6A164.58,164.58,0,0,0,664,99.84a305.05,305.05,0,0,0-43.4-10.65c-15.93-2.76-32.1-4.06-48.28-5-15.19-1-30.47-1-45.75-.65-14.31.33-28.61,1.06-42.83,2.6C472.29,87.41,460.92,89,449.87,92c-10.73,3-21.05,7.47-31.3,12.18-11.21,5.13-21.94,11.3-32.75,17.39-8.12,4.64-16.18,9.52-24.06,14.63a145.06,145.06,0,0,0-11.94,9,47.31,47.31,0,0,0-5.45,5.28",
    transform: "translate(-118.64 -69.63)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M436,87.57a184.34,184.34,0,0,1,31.29-7.4,510.24,510.24,0,0,1,56.81-4.47q34.5-1,68.84,1.22A385.72,385.72,0,0,1,638.18,83a273.49,273.49,0,0,1,31.69,8",
    transform: "translate(-118.64 -69.63)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M475.22,161a10.21,10.21,0,0,1,2.12-.24c1,0,2,.24,2.92.32a26.32,26.32,0,0,0,3.66.09c3.58-.09,7.07-.32,10.56-.65a7,7,0,0,0,1.79-.33,13.83,13.83,0,0,1,1.63-.65,13.28,13.28,0,0,1,2.52-.08c1.62.16,3.25.25,4.79.49a18.31,18.31,0,0,1,3.09.73.83.83,0,0,1,.49.57,2.36,2.36,0,0,1,0,1.06,7.17,7.17,0,0,1-.66,1.87,2.67,2.67,0,0,1-.89,1.05,8.15,8.15,0,0,1-2.43,1c-1.31.32-2.69.48-4.07.73a21.88,21.88,0,0,1-2.27.25,1.57,1.57,0,0,1-.9-.17c-.24-.08-.41-.41-.64-.49a10.43,10.43,0,0,0-1.23-.65,10.08,10.08,0,0,0-2.11-.25c-3.41.09-6.82.17-10.24.5a11,11,0,0,0-2.69.64,8.85,8.85,0,0,0-1.29.73,2.92,2.92,0,0,1-.49.5,8,8,0,0,1-1.95.08c-1.22-.08-2.44-.17-3.66-.33a10.7,10.7,0,0,1-2.11-.48,5.72,5.72,0,0,1-1.22-.58,2.77,2.77,0,0,1-.65-1.06,13.12,13.12,0,0,1-.49-1.7c0-.24-.08-.57-.08-.81s.08-.33.24-.4a3.68,3.68,0,0,1,1.31-.58C471.89,161.61,473.51,161.28,475.22,161Z",
    transform: "translate(-118.64 -69.63)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M633.55,154.94a20.16,20.16,0,0,1,2.19-.16c1,0,2,.33,2.92.41,1.23.08,2.44.16,3.66.16,3.49-.08,7-.24,10.56-.49a6.39,6.39,0,0,0,1.71-.33,16.23,16.23,0,0,1,1.71-.56,8.19,8.19,0,0,1,2.52,0,32.86,32.86,0,0,1,4.8.56,17.31,17.31,0,0,1,3,.74,1,1,0,0,1,.57.57,2.36,2.36,0,0,1-.08,1,7.4,7.4,0,0,1-.65,1.87,3,3,0,0,1-.89,1.06,8.63,8.63,0,0,1-2.53.89,32.75,32.75,0,0,1-4.06.65,21.77,21.77,0,0,1-2.28.25,1.55,1.55,0,0,1-.89-.17c-.25-.08-.32-.41-.57-.57a4.91,4.91,0,0,0-1.3-.57,6.44,6.44,0,0,0-2.11-.32c-3.42,0-6.83,0-10.16.24a14.53,14.53,0,0,0-2.76.58c-.41.15-.81.48-1.3.73-.17.16-.33.48-.49.48a8,8,0,0,1-2,.08,28.44,28.44,0,0,1-3.66-.4,10.06,10.06,0,0,1-2.11-.49,5.66,5.66,0,0,1-1.22-.65,2.92,2.92,0,0,1-.65-1.06c-.17-.56-.25-1.14-.41-1.7,0-.33-.08-.57-.08-.81s.08-.33.24-.42a3.82,3.82,0,0,1,1.31-.56C630.21,155.59,631.91,155.27,633.55,154.94Z",
    transform: "translate(-118.64 -69.63)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M476.11,160.8a24.77,24.77,0,0,1,3.58-2.37,13,13,0,0,1,3.5-1.37,30.86,30.86,0,0,1,4.95-.74,30.11,30.11,0,0,1,5.37.08,12.68,12.68,0,0,1,3.25,1.22,9.56,9.56,0,0,1,2.36,1.79",
    transform: "translate(-118.64 -69.63)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M634.52,154.78a23.48,23.48,0,0,1,3.58-2.19,13.66,13.66,0,0,1,3.49-1.31,24.55,24.55,0,0,1,4.95-.56,30.65,30.65,0,0,1,5.37.15,16,16,0,0,1,3.25,1.23,12.18,12.18,0,0,1,2.36,1.78",
    transform: "translate(-118.64 -69.63)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M477.42,168a11.31,11.31,0,0,0,2.11,2.11,7.08,7.08,0,0,0,2.6,1.22,16.55,16.55,0,0,0,4.06.33,45.2,45.2,0,0,0,4.8-.17,19.25,19.25,0,0,0,3.09-.41,8.75,8.75,0,0,0,2-.89,9.73,9.73,0,0,0,1.79-1.38,10.29,10.29,0,0,0,1.22-1.7",
    transform: "translate(-118.64 -69.63)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M635.65,162.09a9.81,9.81,0,0,0,2,2.12,7,7,0,0,0,2.6,1.29,21.66,21.66,0,0,0,4.06.41,29.6,29.6,0,0,0,4.8-.08,19,19,0,0,0,3.08-.33,13.13,13.13,0,0,0,2-.81,8.33,8.33,0,0,0,1.87-1.46,8.2,8.2,0,0,0,1.22-1.62",
    transform: "translate(-118.64 -69.63)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M470.5,167a7.92,7.92,0,0,1,1.56-.33c1.95-.24,4-.48,6-.56,3.41-.33,6.83-.5,10.24-.66,3.57-.15,7.23-.24,10.81-.32,1.7-.08,3.33-.08,5,0,1.46.08,2.84.25,2.84.25",
    transform: "translate(-118.64 -69.63)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M628.75,160.87a15,15,0,0,1,1.54-.24c2-.24,4-.41,6-.49q5.13-.36,10.24-.48c3.66-.09,7.24-.09,10.9-.09,1.63,0,3.33,0,4.95.09,1.46.08,2.93.32,2.93.32",
    transform: "translate(-118.64 -69.63)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M468.8,163.48s.89-.25,1.87-.41c2.28-.25,4.63-.4,7-.57,3.33-.24,6.74-.41,10.16-.65,3-.08,6-.24,9-.32,1.55-.09,3-.09,4.55-.09,2,0,4.06-.08,6.1,0a9.69,9.69,0,0,1,1.38.33",
    transform: "translate(-118.64 -69.63)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M627.12,157.38a12.1,12.1,0,0,1,1.87-.32c2.28-.25,4.63-.41,7-.5,3.41-.16,6.82-.32,10.24-.4,3-.08,6-.16,9-.16a41.66,41.66,0,0,1,4.47,0c2,0,4.07,0,6.1.08a6.57,6.57,0,0,1,1.38.32",
    transform: "translate(-118.64 -69.63)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500.58,166.89a19.59,19.59,0,0,0,.32-2.2c.08-.81,0-1.7,0-2.52a7.82,7.82,0,0,0,0-1.37,6.83,6.83,0,0,0-.48-1.39",
    transform: "translate(-118.64 -69.63)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M658.82,161.36s.25-1.06.4-2.2v-2.51a7.94,7.94,0,0,0,0-1.38,3.49,3.49,0,0,0-.48-1.3",
    transform: "translate(-118.64 -69.63)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M469.37,162.42s4.87-.49,9.84-.73q9.38-.62,18.77-1c5.12-.16,10.32-.08,10.32-.08",
    transform: "translate(-118.64 -69.63)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M627.69,156.32s5-.4,9.83-.57c6.26-.24,12.52-.48,18.78-.56,5.2-.08,10.32.08,10.32.08",
    transform: "translate(-118.64 -69.63)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.69,161a17,17,0,0,1,2.93-1.46,12.84,12.84,0,0,1,2.6-.64,33.43,33.43,0,0,1,5-.33,12.55,12.55,0,0,1,2.6,0,7,7,0,0,1,1.79.56,17.1,17.1,0,0,1,1.78,1",
    transform: "translate(-118.64 -69.63)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M638.1,155.11a16.75,16.75,0,0,1,2.92-1.47,9.43,9.43,0,0,1,2.6-.57c1.71-.16,3.33-.16,5-.16a14.11,14.11,0,0,1,2.6,0,6.69,6.69,0,0,1,1.79.57,16,16,0,0,1,1.78,1",
    transform: "translate(-118.64 -69.63)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.61,167.3a6.81,6.81,0,0,0,1.46,1.54,6.5,6.5,0,0,0,2.2.81,10.91,10.91,0,0,0,2.92.08,43.88,43.88,0,0,0,5.61-.24,6.14,6.14,0,0,0,2.36-.48,7.35,7.35,0,0,0,1.63-1,9.7,9.7,0,0,0,1.29-1.47",
    transform: "translate(-118.64 -69.63)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M637.85,161.44a5.3,5.3,0,0,0,1.46,1.46,6.81,6.81,0,0,0,2.12.9,17.87,17.87,0,0,0,2.92.16,44.76,44.76,0,0,0,5.69-.08,12.21,12.21,0,0,0,2.36-.48,6.58,6.58,0,0,0,1.54-1,8.25,8.25,0,0,0,1.39-1.47",
    transform: "translate(-118.64 -69.63)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.58,154.21a86.46,86.46,0,0,0-4.15,15.61,196.84,196.84,0,0,0-2,24c-.25,9.83.16,19.58.73,29.42.57,10.08,1.3,20.15,2.68,30.07a8.8,8.8,0,0,0,2.28,5,5.7,5.7,0,0,0,4.22,2l259-5.2c3.65,0,7.23-.33,10.07-1.95s4.79-5,7-8.13c4.88-7.07,9.1-14.79,13.9-22,7-10.49,14.38-20.81,21.53-31.21,6.59-9.51,13.17-19.18,19.76-28.69,7.79-11.14,15.76-22.35,15.76-22.35",
    transform: "translate(-118.64 -69.63)"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 224.67,
    y1: 190.64,
    x2: 202.89,
    y2: 191.21
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M498.71,163.07c.09,0,.16-.08.24-.17s.08-.23-.08-.4a.28.28,0,0,0-.24-.08h-2c-.08,0-.25.08-.25.16a.28.28,0,0,0,0,.41.31.31,0,0,0,.25.08Z",
    transform: "translate(-118.64 -69.63)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M666.7,155.35s23.33-.82,46.65-1.14c23.66-.33,47.22-.65,70.87-.65,23.25-.08,46.49.41,46.49.41",
    transform: "translate(-118.64 -69.63)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830.71,154s4.39.08,8.7.24c2.68.08,5.36.24,5.36.24",
    transform: "translate(-118.64 -69.63)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M872.32,181l-38.93,2a6.15,6.15,0,0,0-2.44.49,4.75,4.75,0,0,0-1.87,1.46,13.56,13.56,0,0,0-1.86,3.17,23.66,23.66,0,0,0-1.79,3.82,2.75,2.75,0,0,0,0,2.27,5.22,5.22,0,0,0,2.28,1.87,77.79,77.79,0,0,0,8.21,3.42,44.55,44.55,0,0,0,8.37,2.27,71.66,71.66,0,0,0,9.42.57l27.23.08",
    transform: "translate(-118.64 -69.63)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.85,180.62A110.93,110.93,0,0,1,188.09,172a268.24,268.24,0,0,1,32.18-7.06c14.63-2.44,29.42-4.07,44.21-5.86,8.86-1.05,17.72-1.7,26.49-2.68,5.61-.56,11.3-.89,16.75-2a37.14,37.14,0,0,0,7.8-2.44,23.87,23.87,0,0,0,6.1-3.49,39.74,39.74,0,0,0,5.77-6.83",
    transform: "translate(-118.64 -69.63)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M344.54,136.33s1.62,1.3,3.16,2.76,2.69,2.85,2.69,2.85",
    transform: "translate(-118.64 -69.63)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.12,238.33a1.85,1.85,0,0,1-.74-.17.56.56,0,0,1-.4-.32,1.18,1.18,0,0,1-.17-.74l.09-17.55-.09-.57h-1",
    transform: "translate(-118.64 -69.63)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.46,172.5s36.9-2.85,74-5.05c46.81-2.76,93.71-4.87,93.71-4.87",
    transform: "translate(-118.64 -69.63)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M508.55,160.8s34.45-1.64,69-2.93c25.11-.89,50.14-1.55,50.14-1.55",
    transform: "translate(-118.64 -69.63)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M533.66,81.8,520,141.45a9.79,9.79,0,0,1-.4,2c-1.14,2.76-2.52,5.45-3.66,8.13a70.79,70.79,0,0,0-3.17,8.45c-.32,1.22.33,2.52.16,3.74-.24,2.44-1,4.79-1.38,7.23-.73,3.74-1.55,7.48-1.95,11.22a157.54,157.54,0,0,0-1.3,16.33c-.08,6.59.33,13.17.81,19.76.25,4.3.89,8.6,1.3,12.92a44,44,0,0,1,.49,4.71c-.08,4.14-.73,8.21-.57,12.27a48.9,48.9,0,0,0,1.06,8.7",
    transform: "translate(-118.64 -69.63)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.12,253.28s25.2-1,50.48-1.63q55.83-1.46,111.67-2.76c79.89-1.71,159.86-3.08,159.86-3.08",
    transform: "translate(-118.64 -69.63)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.05,252.06l50.55-1.3c37.22-.9,74.44-1.95,111.67-2.77,80-1.7,159.94-3.08,159.94-3.08",
    transform: "translate(-118.64 -69.63)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505.45,142.1l-123.93,6A117.26,117.26,0,0,1,383.14,134a76.52,76.52,0,0,1,3-10.65s10.4-6.34,21.21-11.78c9.76-4.87,19.42-9.83,29.58-13.65a189.54,189.54,0,0,1,28.2-7.57,229,229,0,0,1,25.6-3.24c16.35-1.46,32.68-2,32.68-2Z",
    transform: "translate(-118.64 -69.63)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.31,141l105.89-3,5.7-41.62S633,92.93,619.81,90.65c-9.18-1.54-18.45-2.6-27.71-3.49-8.7-.81-17.4-1.3-26.1-1.71-11.94-.49-24-.32-24-.32Z",
    transform: "translate(-118.64 -69.63)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M644.44,137.8l42.18-.74,6.49-9.11a13.43,13.43,0,0,0,2.85-6.49,5.59,5.59,0,0,0-2-4.63,47.89,47.89,0,0,0-10.32-6.75,141.14,141.14,0,0,0-14.79-6.42C659.47,100.17,650,97.4,650,97.4Z",
    transform: "translate(-118.64 -69.63)"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 521.56,
    y1: 68.32,
    x2: 525.79,
    y2: 68.17
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "527.26 26.71 528.55 26.71 530.5 27.28 531.31 27.77"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 386.81,
    y1: 72.47,
    x2: 415.67,
    y2: 71.33
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 404.78,
    y1: 15.5,
    x2: 423.39,
    y2: 15.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 222.89,
    y1: 80.92,
    x2: 262.87,
    y2: 78.48
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346.24,150.31a50.6,50.6,0,0,1,6.18-5.69c4.63-3.5,9.43-6.82,14.31-9.92,9.5-6,19.42-11.38,19.42-11.38",
    transform: "translate(-118.64 -69.63)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M381.19,126.09a100.12,100.12,0,0,0-2.93,10.4,109.57,109.57,0,0,0-1.7,11.95",
    transform: "translate(-118.64 -69.63)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.36,130.15a7.06,7.06,0,0,1,3.9,1.38,9.71,9.71,0,0,1,2.44,3.82,18.77,18.77,0,0,1,1.38,4.55,17,17,0,0,1-.25,4.55,12.15,12.15,0,0,1-.89,3.51,5.77,5.77,0,0,1-2,1.86,5,5,0,0,1-1.79.73,27.18,27.18,0,0,1-4.47.57l-6.17.49.32,4.14a4.37,4.37,0,0,1-.16,1.47c-.16.32-.33.65-.65.73-3.25.32-6.58.32-9.92.4a4.37,4.37,0,0,1-1.46-.08,1.93,1.93,0,0,1-.57-.81,20.33,20.33,0,0,1-1.3-2.6,11.58,11.58,0,0,1-.48-2,13.89,13.89,0,0,1-.5-1.95,9.68,9.68,0,0,1-.16-1.63s-.24-1.06-.48-2c-.33-1.3-.73-2.44-.73-2.44l2.27-.24,28-1.71v-2.52a22.19,22.19,0,0,0-1.22-4.71,12.34,12.34,0,0,0-2.44-3.9A6.23,6.23,0,0,0,384.36,130.15Z",
    transform: "translate(-118.64 -69.63)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M384.36,130.15a3.64,3.64,0,0,0-1.55-.4,29.76,29.76,0,0,0-5.36.32,17.79,17.79,0,0,0-5.2,1.54,50.41,50.41,0,0,0-9.26,6,11.45,11.45,0,0,0-2.85,3.9,2.23,2.23,0,0,0-.08,1.46,13.55,13.55,0,0,0,.33,1.87l2.27-.24,28-1.71v-2.52a22.19,22.19,0,0,0-1.22-4.71,12.34,12.34,0,0,0-2.44-3.9A6.23,6.23,0,0,0,384.36,130.15Z",
    transform: "translate(-118.64 -69.63)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.66,144.62l28-1.71v-2.52l-25.93,1.55a2.34,2.34,0,0,0-1.7.73,2.72,2.72,0,0,0-.33,2Z",
    transform: "translate(-118.64 -69.63)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.91,149.82a6,6,0,0,0,1-2.28,24,24,0,0,0,.66-4.63",
    transform: "translate(-118.64 -69.63)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.48,151.61a26.77,26.77,0,0,1-6.67-.16c-2-.33-4-.73-5.2-1.87-1.79-1.71-1.95-5-1.95-5",
    transform: "translate(-118.64 -69.63)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M360,142.1s7.48-.73,14.95-1.22c7.8-.49,15.61-.81,15.61-.81",
    transform: "translate(-118.64 -69.63)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.91,146.65,376.31,148a1.47,1.47,0,0,0-.81.31.62.62,0,0,0-.25.5.49.49,0,0,0,.25.48,3.61,3.61,0,0,0,1.46.57,13.69,13.69,0,0,0,2.52.32c1.14.09,2.28.09,3.42.09,2.11,0,4.22-.17,4.22-.17",
    transform: "translate(-118.64 -69.63)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.14,254.91a62.79,62.79,0,0,1,.16-10.08,90.6,90.6,0,0,1,2.85-17.89,68.44,68.44,0,0,1,9-19.66,64.73,64.73,0,0,1,35.36-26.17,76.87,76.87,0,0,1,22.59-3.25,74.14,74.14,0,0,1,21.94,3.33,68.94,68.94,0,0,1,20.32,10,66.28,66.28,0,0,1,24,34,99.81,99.81,0,0,1,3,16c.57,4,1,6,2.11,7.07s3,1.06,11.79.81,24.47-.89,49.9-1.62,60.63-1.54,93.06-2.28,62.17-1.3,85.25-1.62,39.5-.41,49-.57,12.12-.49,13.57-1.46,1.79-2.84,2.2-5a52,52,0,0,1,2.19-9,70.74,70.74,0,0,1,7.48-16.25,63.87,63.87,0,0,1,36.17-27.07,79.57,79.57,0,0,1,47.71,0,67.83,67.83,0,0,1,20.56,10.24,65,65,0,0,1,14.71,15.69A64.14,64.14,0,0,1,771.46,225c1.46,4.22,2,7.15,2.6,9.18s1.14,2.92,2,3.5a5.24,5.24,0,0,0,2.93.56L878,232.88c.17-.08.32-.08.25-.65s-.66-1.55-1-2.44a8.56,8.56,0,0,1-.73-2.85,12.5,12.5,0,0,1,.24-3.41",
    transform: "translate(-118.64 -69.63)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M876.63,237.27a.36.36,0,0,1,.08.25.29.29,0,0,1-.08.24L875,240.44a.93.93,0,0,1-.41.49,2.31,2.31,0,0,1-.74.08l-22,1.3a1.14,1.14,0,0,1-.48-.16c-.09-.08-.25-.17-.33-.25s-.32-.24-.25-.32.41-.24.66-.49c.81-.57,1.54-1.22,2.35-1.71a9.56,9.56,0,0,1,1.39-.64,7.71,7.71,0,0,1,2-.25Z",
    transform: "translate(-118.64 -69.63)"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 758.8,
    y1: 167.56,
    x2: 757.99,
    y2: 167.64
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 749.3,
    y1: 171.79,
    x2: 751.4,
    y2: 168.05
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 651.6,
    y1: 152.12,
    x2: 723.29,
    y2: 148.29
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 759.61,
    y1: 162.76,
    x2: 761.97,
    y2: 162.6
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 216.22,
    y1: 165.36,
    x2: 512.95,
    y2: 155.77
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.84,184.85s11.38-9,24.38-14.06C179,165.91,192.56,163,206.05,160c11.86-2.6,23.89-4.14,36-5.85,13.33-1.87,26.66-3.41,40-5,11.13-1.21,22.35-2.11,33.48-3.33,8.86-1.06,17.88-1.31,26.33-3.41,3.91-1,7.24-3.82,10.89-6,12.27-7.23,24.06-15.2,36.58-22,13.08-7.15,26.24-14.46,40-19.82a177.92,177.92,0,0,1,36.9-10.49c19.18-3,38.85-3.74,58.43-4.64,14.4-.64,28.78-.48,43.08.17,17.23.81,34.38,1.7,51.28,4.15a321.08,321.08,0,0,1,43.57,9.58c17.39,5,34.37,11.55,51.45,17.89,13.73,5.2,27.06,11.29,40.71,16.65,6.5,2.61,12.92,5.53,19.59,7.32,5.61,1.47,11.54,2,17.39,2.69,9.35,1,18.7,1.37,28.12,2.19,11.46,1,23,2.19,23,2.19",
    transform: "translate(-118.64 -69.63)"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 647.54,
    y1: 173.08,
    x2: 761.97,
    y2: 166.75
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.38,217.61l40.8-7.73a53.41,53.41,0,0,0,18.94-7.15,58.93,58.93,0,0,0,7.39-5.44",
    transform: "translate(-118.64 -69.63)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.09,206.47a16.92,16.92,0,0,1,2.12-.66c1.06-.23,2.12-.4,2.12-.4l.89-2.76-1.55-.17-1.95-.08c-.16-.08-.32-.08-.4-.16a.29.29,0,0,1-.08-.24,3.25,3.25,0,0,1,.32-.81.27.27,0,0,1,.09-.16.21.21,0,0,1,.15-.09.65.65,0,0,1,.08-.33.64.64,0,0,1,.33-.32,4.67,4.67,0,0,0,1-.32,7.15,7.15,0,0,0,1.22-.33c1-.17,1.94-.4,1.94-.4l1.06-2.77-1.54-.24-1.87-.08a.78.78,0,0,1-.49-.17c-.08-.08,0-.16,0-.32s.24-.49.32-.74l.17-.15a.64.64,0,0,1,.16-.41.44.44,0,0,1,.33-.17,5.6,5.6,0,0,1,1.54-.48,5.19,5.19,0,0,1,1.06-.33c.81-.16,1.54-.24,1.54-.24l1.06-2.6-1.71-.25h-.16a.24.24,0,0,1-.08-.15l-1.46-.09c-.08,0-.08,0-.17-.08s-.08-.16-.08-.16a.65.65,0,0,1-.41,0,.31.31,0,0,1-.08-.25c.16-.4.33-.73.49-1.14,0-.08.08-.08.08-.15a2.71,2.71,0,0,0,.32-.41l-1.05.24h-.08c-.08.08-.08.08-.08.17l-.08.23s-.58,1.55-1.14,3c-.57,1.63-1.3,3.33-1.87,5.05-.89,2.76-1.79,5.6-2.68,8.36-.73,2.28-1.38,4.55-1.38,4.55a2,2,0,0,0-.08.33,1.32,1.32,0,0,0,.48.25l4.15,1,.57-2a.08.08,0,0,1,.08-.08h.16v-.09l-1.71-.24L125,208.5l-.4.08a1.14,1.14,0,0,1-.41-.08v-.16c.08-.33.17-.66.25-.89s.08-.17.16-.25h.25a1.24,1.24,0,0,1-.17-.33A1,1,0,0,1,125.09,206.47Z",
    transform: "translate(-118.64 -69.63)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.53 138.3 25.07 136.76 15.07 138.71 14.91 139.19 10.76 139.76 10.28 141.31 26.53 138.3"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "6.21 137.57 11.01 136.92 23.36 134.64"
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 567.97,
    y1: 67.43,
    x2: 574.15,
    y2: 67.43
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M389.07,149.74s39.1-2.44,78.19-4.23c37.22-1.62,74.45-3.16,111.67-4.22,56.24-1.71,112.56-2.36,112.56-2.36",
    transform: "translate(-118.64 -69.63)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.6,149.33a11.73,11.73,0,0,0,1.71,2.28,3.46,3.46,0,0,0,1,.32c1,.17,2,.25,2.93.41,2.43.33,4.88.57,7.31.73.5,0,.9.08,1.14-.08a2.81,2.81,0,0,0,.82-1.38",
    transform: "translate(-118.64 -69.63)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.68,150.06a9.09,9.09,0,0,0,1.63,2.12c.24.24.57.24,1,.33,1,.16,2,.32,3.09.4,2.44.24,4.88.57,7.32.73.4.08.81.16,1.06-.08a2.78,2.78,0,0,0,.81-1.3",
    transform: "translate(-118.64 -69.63)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M363.15,147l.81,4.87a.3.3,0,0,0-.16.25,2.28,2.28,0,0,0-.08.73c.4,2.68.89,5.44.89,5.44",
    transform: "translate(-118.64 -69.63)"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 221.66,
    y1: 82.95,
    x2: 243.21,
    y2: 81.74
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M378,130a6.89,6.89,0,0,1,3.82,1.38,10.69,10.69,0,0,1,2.36,3.82,35,35,0,0,1,1.54,5.12",
    transform: "translate(-118.64 -69.63)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M120.71,252.23l3.57-.09c.33,0,.65-.08.9.09a10.37,10.37,0,0,1,1.06,1,12.6,12.6,0,0,0,1,1.06,4.15,4.15,0,0,0,1.38.81,8.57,8.57,0,0,0,2.44.32l47.38-2a7,7,0,0,0,3.09-.74,1.83,1.83,0,0,0,.4-1.87,8.2,8.2,0,0,0-1.29-2.68",
    transform: "translate(-118.64 -69.63)"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 4.02,
    y1: 190.56,
    x2: 15.16,
    y2: 190.07
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.86,203.62l-1.3-1.78-1.71.32h.09v.08l-1,2Z",
    transform: "translate(-118.64 -69.63)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.92,204.19h-.65c-.08.08-.16,0-.24,0h-.17v-.08c0-.08.17-.16.17-.16v-.08a1,1,0,0,0-.17-.25",
    transform: "translate(-118.64 -69.63)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "6.37 138.87 10.6 138.3 24.41 135.78"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.24,207.93s-.32,0-.41-.17c-.08,0,0-.16,0-.23a1.49,1.49,0,0,1,.33-.58c0-.08.08-.24.17-.24.08-.16.32-.16.32-.16",
    transform: "translate(-118.64 -69.63)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "8.16 131.31 13.6 130.66 19.62 129.69"
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 12.39,
    y1: 120.18,
    x2: 19.46,
    y2: 119.45
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.43,187.86a6.45,6.45,0,0,1,.58-.65,9.21,9.21,0,0,1,1-1.14",
    transform: "translate(-118.64 -69.63)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129,194.77a.4.4,0,0,0,.24-.08l6.18-.66",
    transform: "translate(-118.64 -69.63)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.18,199.24h-.56c-.09,0-.17,0-.17-.08s-.08-.09-.08-.09.25-.16.16-.24l-1.78-3.41-.09-.09h.09a.37.37,0,0,1,.23-.08",
    transform: "translate(-118.64 -69.63)"
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 10.36,
    y1: 126.52,
    x2: 17.02,
    y2: 125.7
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 16.05,
    y1: 120.91,
    x2: 18.4,
    y2: 121.15
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132.74,190.14s0-.09.08-.09.08-.08.16-.08l4.87-.49",
    transform: "translate(-118.64 -69.63)"
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 12.63,
    y1: 120.18,
    x2: 14.34,
    y2: 120.34
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.43,199.24s-.08.16,0,.16.09.07.09.07l5.93-.81",
    transform: "translate(-118.64 -69.63)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.63,193.14a.08.08,0,0,0,.08.08h.17l1.7-.17",
    transform: "translate(-118.64 -69.63)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "17.02 123.19 15.15 123.42 15.07 123.42 14.99 123.51"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 15.97,
    y1: 123.34,
    x2: 16.94,
    y2: 120.99
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 14.18,
    y1: 120.58,
    x2: 19.05,
    y2: 120.1
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.23,196.39l-1.06-.16H135l-.07.08-.09.32-1.46-.24h-.17a.07.07,0,0,1-.07.08l-.66-.08h-.08v.08",
    transform: "translate(-118.64 -69.63)"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "12.23 126.6 12.23 126.52 17.18 125.94"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "7.92 132.69 13.2 132.04 20.44 130.9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M132.25,200.29a4,4,0,0,0-.41.49,1.32,1.32,0,0,0-.24.73c0,.16.24.16.24.16",
    transform: "translate(-118.64 -69.63)"
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 20.92,
    y1: 132.21,
    x2: 20.03,
    y2: 130.98
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "9.71 132.85 15.64 132.04 20.27 131.31"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 15.64,
    y1: 132.04,
    x2: 19.21,
    y2: 132.53
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 5.97,
    y1: 180.23,
    x2: 3.37,
    y2: 174.79
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2.72,
    y1: 178.69,
    x2: 2.31,
    y2: 176.66
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125,235.08l38.44-2.53a30.58,30.58,0,0,1,3.83,0,9.46,9.46,0,0,1,2.52.58",
    transform: "translate(-118.64 -69.63)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.86,250.36l54-2.28h.73a8.16,8.16,0,0,0,.82-.24",
    transform: "translate(-118.64 -69.63)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M197.84,253.77l-64.45,2.76a20,20,0,0,1-2.19,0,10.86,10.86,0,0,1-2.2-.25",
    transform: "translate(-118.64 -69.63)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M121.2,261.08l53.47-2.35a13,13,0,0,0,3-.49c1.06-.32,2-1.06,3.09-1.46a2.64,2.64,0,0,1,1.38-.33l15.69-.65",
    transform: "translate(-118.64 -69.63)"
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 6.37,
    y1: 184.47,
    x2: 7.43,
    y2: 184.55
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.69,
    y1: 184.06,
    x2: 6.78,
    y2: 183.89
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 4.75,
    y1: 184.47,
    x2: 7.18,
    y2: 184.3
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141,203.79l-11.14,1.87c-.25,0-.4.08-.48,0s0-.25,0-.25",
    transform: "translate(-118.64 -69.63)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.33,205.58h0a.24.24,0,0,1,.16-.09l7.47-1.22",
    transform: "translate(-118.64 -69.63)"
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 16.37,
    y1: 134.97,
    x2: 17.59,
    y2: 132.29
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "8.08 139.03 12.79 138.3 24.74 136.18"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.35,199.4a.08.08,0,0,1,.08-.08c0-.08.09-.08.09-.08l5.85-.74",
    transform: "translate(-118.64 -69.63)"
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 13.52,
    y1: 129.53,
    x2: 14.5,
    y2: 126.84
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 16.21,
    y1: 127,
    x2: 15.23,
    y2: 129.36
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 13.77,
    y1: 129.53,
    x2: 14.75,
    y2: 126.76
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 15.39,
    y1: 129.28,
    x2: 16.53,
    y2: 126.6
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 17.34,
    y1: 129.03,
    x2: 18,
    y2: 127.49
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.41,194.69a.08.08,0,0,1-.08-.09c0-.08,0-.08.08-.16s.24-.08.32-.16a8,8,0,0,1,1.38-.41,15.35,15.35,0,0,1,2.6-.57l1.79-.25",
    transform: "translate(-118.64 -69.63)"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "11.58 133.02 12.23 133.1 12.31 133.02 13.85 133.18 14.02 132.85 15.72 133.02 15.88 132.77 17.26 132.94"
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 14.99,
    y1: 135.21,
    x2: 15.72,
    y2: 133.02
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 13.04,
    y1: 135.54,
    x2: 13.85,
    y2: 133.18
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 11.42,
    y1: 135.78,
    x2: 12.23,
    y2: 133.1
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.21,200.94a663442882562.22,663442882562.22,0,0,1-.16-.16c.08-.08.08-.08.08-.17l.81-.24a8.78,8.78,0,0,1,1.55-.4,15.26,15.26,0,0,1,1.94-.41l6.1-.82",
    transform: "translate(-118.64 -69.63)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.09,207.12,125,207V207c.08,0,.08-.08.17-.08s.57-.24.81-.32c.89-.24,1.79-.49,2.6-.65l12.44-2",
    transform: "translate(-118.64 -69.63)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M133.71,208.34l-2.28-.33-2.6.41,1.87.24c0,.08.09.08.17.08v.08l-.08.41",
    transform: "translate(-118.64 -69.63)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.43,208.9l.08-.08.9.17c.08,0,.08,0,.08.08l-.08.33",
    transform: "translate(-118.64 -69.63)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.62,209.23l.17-.33c0-.08,0-.08-.09-.08s0-.08-.08-.08l-2-.32-1,.16,2,.32a.09.09,0,0,1,.09.09v.08l-.09.33",
    transform: "translate(-118.64 -69.63)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122.5,207.6s1.22-4.39,2.59-8.69c1.47-4.63,3.1-9.27,3.1-9.27",
    transform: "translate(-118.64 -69.63)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122.91,209.47s1.29-5.12,2.76-10.23c1.62-5.29,3.41-10.57,3.41-10.57",
    transform: "translate(-118.64 -69.63)"
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 12.15,
    y1: 171.05,
    x2: 13.29,
    y2: 164.96
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 528.55,
    y1: 26.71,
    x2: 522.7,
    y2: 68.24
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 530.5,
    y1: 27.28,
    x2: 524.81,
    y2: 68.24
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.73,246.37l.57.08.66-.08v.08a.08.08,0,0,0,.08.09l32.5-1.39c.33,0,.65,0,.65-.16s-.16-.57-.4-1c-.73-1.31-1.54-2.52-2.36-3.74a11.92,11.92,0,0,0-2-2.44,8.63,8.63,0,0,0-2.6-1.55,12.9,12.9,0,0,0-3.9-.32L146.06,237l-.07.17-7.4-.81-2.44.08",
    transform: "translate(-118.64 -69.63)"
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.29,
    y1: 172.44,
    x2: 54.73,
    y2: 169.18
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "11.65 180.48 11.82 173.57 55.87 170.73"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "3.29 173.73 24.9 172.44 55.63 170.4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.46,242.39l-.73,4-1,.33c-1.46.32-3,.65-4.47.89a18.64,18.64,0,0,1-3.25.33v.24l41.12-1.71a10.71,10.71,0,0,0,2.36-.24c.41-.16.73-.49.64-.82a3.34,3.34,0,0,0-.73-1.78,32.89,32.89,0,0,0-2.43-3.91,12.18,12.18,0,0,0-2.44-2.83,7.76,7.76,0,0,0-2.92-1.79,15.31,15.31,0,0,0-4.72-.57l-28.61,1.78-1.06,4.15L125,241",
    transform: "translate(-118.64 -69.63)"
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 3.21,
    y1: 172.11,
    x2: 54.49,
    y2: 168.94
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 26.61,
    y1: 170.65,
    x2: 27.34,
    y2: 167.56
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "26.61 170.4 25.31 170.24 16.53 170.81"
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 26.13,
    y1: 167.39,
    x2: 25.31,
    y2: 170.24
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 15.88,
    y1: 170.81,
    x2: 15.39,
    y2: 164.88
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 25.31,
    y1: 176.74,
    x2: 26.13,
    y2: 172.68
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 24.42,
    y1: 174.87,
    x2: 57.41,
    y2: 173.08
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 25.63,
    y1: 169.26,
    x2: 52.86,
    y2: 167.56
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 6.95,
    y1: 171.38,
    x2: 6.95,
    y2: 165.36
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 8.57,
    y1: 171.3,
    x2: 8.65,
    y2: 165.29
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 11.74,
    y1: 171.05,
    x2: 11.82,
    y2: 165.12
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 6.29,
    y1: 173.57,
    x2: 6.62,
    y2: 180.73
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 6.95,
    y1: 173.49,
    x2: 7.35,
    y2: 180.73
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 8.89,
    y1: 180.64,
    x2: 8.57,
    y2: 173.41
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.8,259.38l51.28-2.2a8.94,8.94,0,0,0,1.46-.16,15,15,0,0,0,2.52-.89c.16-.08-.07-.16-.32-.16L134,257.84a7.53,7.53,0,0,1-2-.17,3.55,3.55,0,0,1-1.22-.41",
    transform: "translate(-118.64 -69.63)"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "6.62 189.5 7.18 189.42 7.18 189.5 8.41 189.34 8.41 189.42 10.68 189.1 10.68 189.34 13.77 188.85 15.15 188.85"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 15.16,
    y1: 189.34,
    x2: 15.16,
    y2: 188.2
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 13.77,
    y1: 188.85,
    x2: 13.69,
    y2: 188.12
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 7.18,
    y1: 189.42,
    x2: 6.86,
    y2: 184.55
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 8.41,
    y1: 189.34,
    x2: 8.16,
    y2: 185.2
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 10.68,
    y1: 189.1,
    x2: 10.52,
    y2: 186.82
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.08,188.67a.4.4,0,0,0,.25-.09,4.72,4.72,0,0,1,.81-.08",
    transform: "translate(-118.64 -69.63)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaloon);
export default __webpack_public_path__ + "static/media/saloon.ab9f173623063bd4af12c04974d2edc6.svg";
export { ForwardRef as ReactComponent };